angular.module('PTK.controllers.Play', [])

.controller('playCtrl', ['$scope',  '$log', 'Service', 'Message', '$uibModal', '$sce', '$routeParams', '$location', '$timeout', 'Upload', '$interval', '$animate', '$window', '$route',
  function($scope, $log, Service, Message, $uibModal, $sce, $routeParams, $location, $timeout, Upload, $interval, $animate, $window, $route) {

  $scope.disabled = undefined;
  $scope.language = {};
  $scope.language.selected = '';
  $scope.language_list = [{'name': 'english', 'url': 'https://raw.githubusercontent.com/stevenrskelton/flag-icon/master/png/16/country-4x3/gb.png'},{'name': 'italian', 'url': 'https://raw.githubusercontent.com/stevenrskelton/flag-icon/master/png/16/country-4x3/it.png'}];
    
	$scope.animationsEnabled = true;
	
	$scope.loadinganim = "";
	$scope.loading = true;
	
	$scope.feltoltes = "";
	$scope.feltoltescomm = "";
	$scope.animchange=0;
  
	$scope.xmeret = "100%";
	$scope.ymeret = "600px";

	$scope.xmeret_num = "100";
	$scope.ymeret_num = "600";

	
	$scope.cim = "";
	$scope.id = "";
	$scope.cimlathato = true;
	$scope.items = [];
	$scope.origitems = [];
	$scope.isSelected = {};	
	$scope.show = true;
	$scope.files = [];
	$scope.templates = [];
	$scope.styles = [];
	
	$scope.package = {};
	$scope.package_selected = "";
	$scope.package_selected_title = "";
	$scope.pages = [];
	$scope.pagesall = 0;
	$scope.page_pointer = 0;
	$scope.page_pointer_real = 1;
	
	$scope.progress = [];
	$scope.progresstimer = 0;
	$scope.background = "";
	$scope.background_selopt = {};
	$scope.background_color = "";
	$scope.elemvalasztva = false;
	$scope.itemanimonexit = 0;
	$scope.commontofront = 0;
	$scope.page_common_selopt = {};
	$scope.page_common = [];
	
	
	$scope.itemdata = {};
	$scope.itemdata.selitemname = "";
	$scope.itemdata.selvisibleonstart = 1;  //elem látható megjelenításkor
	$scope.itemdata.background_selopt_item = {};
	$scope.itemdata.meret100 = 0;
	$scope.itemdata.kepszoveggel = 1;
	$scope.itemdata.aranyos = 1;
	$scope.itemdata.sablon_selopt_item = {};
	$scope.itemdata.stilus_selopt_item = {};
	$scope.itemdata.selx = 0;
	$scope.itemdata.sely = 0;	
	$scope.itemdata.selw = 0;
	$scope.itemdata.selh = 0;
	$scope.itemdata.selp = 0;
	$scope.itemdata.vidh = 0;
	$scope.itemdata.vida = 0;
	$scope.itemdata.vidk = 0;
	$scope.itemdata.elemtipus = "";

	$scope.itemdata.selo = "hidden";
	$scope.itemdata.selm = "hidden";
	$scope.itemdata.selmo = "hidden";
	$scope.selposter = "";

	$scope.itemdata.selshowitemsclick = "";
	$scope.itemdata.selshowitemsover = "";
	$scope.itemdata.selhideitemsclick = "";
	$scope.itemdata.selhideitemsleave = "";
	
	$scope.itemdata.behuz = 0;
	
	$scope.fileinit = true;
	$scope.templateinit = true;
	$scope.styleinit = true;
	
	$scope.itemdata.poster_selopt_item = {};

	$scope.itemdata.displaystart_selopt_item = {};
	$scope.itemdata.displayend_selopt_item = {};
	$scope.itemdata.anim_selopt_item = {};
	$scope.times = [];
	$scope.itemvisibilities = {};
	$scope.timertasks = [];
	
	$scope.adminmode = false;
	$scope.simplemode = true;
	
	$scope.sizesarray = {};
	
	$scope.packagestyles = "";
	$scope.templatestyles = "";
	$scope.stylestyles = "";
	$scope.privatestyles = "";
	
	$scope.videoconfigs = {};
	
	$scope.mytext="";
	$scope.mystyle="";
	
	$scope.mypid = "";
	$scope.urltomb = [];
	$scope.urltomb = document.location.hash.split("/");
	$scope.APIS = [];
	
	$scope.videoloading = false;
	$scope.meretezesirany = 0;
	$scope.meretezesreferencia = 0;
	$scope.meretezesmeret = 0;
	
	$scope.snaptogrid = 0;
	$scope.pageturn = false;
	
	$scope.rajzparok = [];
	
	$scope.animations = [
						{anim_id: 0, anim_title: "Nincs", anim_type: "" },
						{anim_id: 1, anim_title: "Megjelenés", anim_type: "toggle"}, 
						{anim_id: 2, anim_title: "Fordulás", anim_type: "spin-toggle"}, 
						{anim_id: 3, anim_title: "Méretezés kicsiből", anim_type: "scale-fade"}, 
						{anim_id: 4, anim_title: "Méretezés nagyból", anim_type: "scale-fade-in"}, 
						{anim_id: 5, anim_title: "Méretezés nagyból rugós", anim_type: "bouncy-scale-in"}, 
						{anim_id: 6, anim_title: "Bedöntés vízszint", anim_type: "flip-in"}, 
						{anim_id: 7, anim_title: "Csúszás balról", anim_type: "slide-left"}, 
						{anim_id: 8, anim_title: "Csúszás jobbról", anim_type: "slide-right"}, 
						{anim_id: 9, anim_title: "Csúszás lentről", anim_type: "slide-top"}, 
						{anim_id: 10, anim_title: "Csúszás fentről", anim_type: "slide-down"}, 
						{anim_id: 11, anim_title: "Rugó balról", anim_type: "bouncy-slide-left"}, 
						{anim_id: 12, anim_title: "Rugó jobbról", anim_type: "bouncy-slide-right"}, 
						{anim_id: 13, anim_title: "Rugó lentről", anim_type: "bouncy-slide-top"}, 
						{anim_id: 14, anim_title: "Rugó fentről", anim_type: "bouncy-slide-down"}, 
						{anim_id: 15, anim_title: "Bedöntés függőleges", anim_type: "rotate-in"}
						];
	
	
	//console.log($scope.urltomb);
	//console.log("bükk");
	
	$scope.getautohide = function (id){
		
		if ( $scope.items[$scope.getselected(id)].autohide == "0" ){
			return false;
		}else{
			return true;
		}
	}
	
	$scope.getautohidetime = function (id){
		
		return $scope.items[$scope.getselected(id)].autohide * 1000;
		
	}
	
	$scope.onUpdateTime = function ($currentTime, $duration){
		
		$scope.videoloading = false;
		
		function timerComplete () {
			$scope.videoloading = false;
		}

		if ( $scope.videoloading == true){
			setTimeout(timerComplete, 200);
		}
		
	}
	
	$scope.onChangeSource = function ($source){
	}
	
	$scope.onPlayerReady = function(API, id) {
		$scope.APIS[id] = API;
		
		if ( $scope.items[$scope.getselected(id)].autoplay == "1" ){
			$scope.APIS[id].autoPlay = true;
		}else{
			$scope.APIS[id].autoPlay = false;			
		}
	};	
	
	$scope.toggleAutoplay = function(id, value) {
		if(id in $scope.APIS){
			$scope.APIS[id].autoPlay = value;
		};
	};

/* test-code */		

		$scope.export_link = function(){
			console.log ("export_link");
			$window.open( Service.remote_host + 'player/index.html#/play/'+Service.valasztottcsomag , '_blank'); 
		}
	
		$scope.export_html = function(){
			console.log ("export_html");
			$window.open( Service.remote_host + 'getpackage.php?type=html&id='+Service.valasztottcsomag , '_blank'); 
		}

		$scope.export_scorm = function(){
			console.log ("export_scorm");
			$window.open( Service.remote_host + 'getpackage.php?type=scorm&id='+Service.valasztottcsomag , '_blank'); 
		}
		
	
/* end-test-code */		 
	
	
/* test-code */		
	$scope.toggleadmin = function (){
		$scope.adminmode = !$scope.adminmode;
		$scope.initpage();
	}
	
	$scope.togglesimple = function (){
		$scope.simplemode = !$scope.simplemode;
	}
	
	$scope.routedblclick = function (id){
		
		if ($scope.adminmode){
			$scope.szerkeszt('lg');
		}else{
			return;
		}
		
	}
	
/* end-test-code */		 
	 
	$scope.routeclick = function (id, $event){
		
		console.log ($event);
		
		if ($scope.adminmode){
			$scope.selectBlock(id, $event);
		}else{
			$scope.nagyit('lg',id);
		}
		
	}
	
	$scope.notifyServiceOnChage = function(){
	};
	
	$scope.loadinganim = "content/common/loading_anim.gif";
	
	if ( angular.isDefined(Service.jsonpid) &&  Service.jsonpid != "") {
		Service.offline = true;
		$scope.mypid = Service.jsonpid;
		Service.valasztottcsomag = $scope.mypid;
		Service.getpackages();
		
	}else if ( window.location.protocol == "http:" || window.location.protocol == "https:"){
		
		$scope.loadinganim = Service.remote_host+$scope.loadinganim;
		
		Service.offline = false;
			
		if ($routeParams.packageId){
			$scope.mypid = $routeParams.packageId;
			Service.valasztottcsomag = $scope.mypid;
			Service.getpackages();
		}else if ($scope.urltomb[0] == "#" && $scope.urltomb[1] == "play" && $scope.urltomb[2]!= "" && $scope.urltomb[2]!= undefined){
			$scope.mypid = $scope.urltomb[2];
			Service.valasztottcsomag = $scope.mypid;
			
			if ( $scope.urltomb[3]!= "" && $scope.urltomb[3]!= undefined ){
				Service.valasztottlap = $scope.urltomb[3];
			}
			
			Service.getpackages($scope.mypid);
		}else if (Service.loggedin){
			//Service.getpackages("");
		} else{
			$location.path('/login');
		}
	} else {
		return;
	}
	
/* test-code */		
	if (!Service.loggedin && !$scope.mypid){
		$location.path('/login');
	}

	$scope.editstyle = function () {
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		
 		if (mysorszam != -1){

			$scope.mystyle = $scope.items[mysorszam].style_data;

			var modalInstance = $uibModal.open({
					  animation: $scope.animationsEnabled,
					  templateUrl: 'Stilusszerkeszto.html',
					  controller: 'StyleInstanceCtrl',
					  size: "lg",
					  resolve: {
						mystyle: function () {
							return $scope.mystyle;
						}
					}
			});
			
			modalInstance.result.then(function (mystyle) {
				
				$scope.items[mysorszam].style_data = mystyle;
				$scope.saveitems();
				$scope.getprivatestyles();
				
			}, function () {
			  $log.info('Modal dismissed at: ' + new Date());
			});
		}
	};
	
	$scope.editpopuptitle = function () {

	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		
 		if (mysorszam != -1){

			$scope.mytitle = $scope.items[mysorszam].nagycim;

			var modalInstance = $uibModal.open({
					  animation: $scope.animationsEnabled,
					  templateUrl: 'PopupCimszerkeszto.html',
					  controller: 'PopupTitleInstanceCtrl',
					  size: "lg",
					  resolve: {
						mytitle: function () {
							return $scope.mytitle;
						}
					}
			});
			
			modalInstance.result.then(function (mytitle) {
				
				$scope.items[mysorszam].nagycim = mytitle;
				$scope.saveitems();
				
			}, function () {
			  $log.info('Modal dismissed at: ' + new Date());
			});
		}
	};
/* end-test-code */	
	
	$scope.$watch(function () { return Service.templates; },function (value) {
	
		if ( value.length == 0 && $scope.templateinit){
			$scope.templateinit = false
			return;
		}
	
		$scope.templates = [ { "template_id": "", "template_package_id": "", "template_title": "Nincs"  } ];
		
		for(var i = 0; i < value.length; i++){
			var patt = new RegExp( "^" + $scope.package_selected + "$", "i");
			if (  ( patt.test(value[i].template_package_id) || value[i].template_package_id == "" ) && value[i].template_hidden == "0" ){
				$scope.templates.push(value[i]);
			}
		}

		$scope.itemdata.sablon_selopt_item = $scope.templates[0];
		$scope.gettemplatestyles();
		
	});	

	$scope.$watch(function () { return Service.styles; },function (value) {
	
		if ( value.length == 0 && $scope.styleinit){
			$scope.styleinit = false
			return;
		}
	
		$scope.styles = [ { "style_id": "", "style_package_id": "", "style_title": "Nincs"  } ];
		
		for(var i = 0; i < value.length; i++){
		
			var patt = new RegExp( "^" + $scope.package_selected + "$", "i");
			if (  ( patt.test(value[i].style_package_id) || value[i].style_package_id == "" ) && value[i].style_hidden == "0" ){
				$scope.styles.push(value[i]);
			}
		}

		$scope.itemdata.stilus_selopt_item = $scope.styles[0];
		$scope.getstylestyles();
		
	});	

/* test-code */		
     $scope.$watch('feltoltes', function () {
        $scope.upload($scope.feltoltes, "package");
    });

     $scope.$watch('feltoltescomm', function () {
        $scope.upload($scope.feltoltescomm, "common");
    });
	
	$scope.upload = function (files, param) {
        if (files && files.length) {
            for (var i = 0; i < files.length; i++) {
              var file = files[i];
              if (!file.$error) {
                Upload.upload({
                    url: Service.remote_host +'/upload.php?type=' + param,
                    data: {
                      csomag: $scope.package_selected ,
                      file: file  
                    }
                }).then(function (resp) {
                    $timeout(function() {
						
						if (resp.data.message == '1'){
							Service.getres($scope.package_selected, file.name, param);
						}
						
                    });
                }, null, function (evt) {
                    var progressPercentage = parseInt(100.0 *
                    		evt.loaded / evt.total);
                    $scope.log = 'progress: ' + progressPercentage + 
                    	'% ' + evt.config.data.file.name + '\n' + 
                      $scope.log;
                });
              }
            }
        }
    };
/* end-test-code */	

	$scope.getpagebyid = function (id){
		var mydata = $scope.pages;
		for(var i = 0; i < mydata.length; i++){
			if ( mydata[i].page_id == id){
				return mydata[i];
			}
		}
	}

	$scope.getpagebyalias = function (id){
		var mydata = $scope.pages;
		for(var i = 0; i < mydata.length; i++){
			if ( mydata[i].page_alias== id){
				return mydata[i];
			}
		}
	}
	
/* test-code */		
	$scope.addbeforePage = function (){
	
		var mydata = $scope.pages;
		var sorszam = -1;
		var valasztottsorrend;
		valasztottsorrend = 0;

		for(var i = 0; i < mydata.length; i++){
				if ( parseInt(mydata[i].page_order) > valasztottsorrend){
					valasztottsorrend = parseInt(mydata[i].page_order);
				}
		}	
		valasztottsorrend++;
		
		var newguid = Service.guid();
	
		mydata.push({
						"page_id": newguid,
						"page_package_id": $scope.package_selected,
						"page_title": "Új lap",
						"page_items": [],
						"page_style": "",
						"page_meta": "",
						"page_background": "",
						"page_background_color": "",
						"page_hidden": "0",
						"page_order": valasztottsorrend
		});
	
		$scope.pages = mydata;
		
		//$log.log ("Lap update: " + newguid);
		Service.updatepage($scope.getpagebyid(newguid));

		
	}
/* end-test-code */
	
	$scope.getanimsource = function (szoveg){
		
		if (!$scope.isanim(szoveg)){
			return;
		}else{
			var regExp = /{animation}([\s\S]*){\/animation}/;
			var matches = regExp.exec(szoveg);
			
			var value = matches[1];
			
			if (Service.offline){
				value = value.replace(/^http:\/\/[^\/]*?\//g,"");
			}

			value = value.replace(/ /g,"%20");
			
			if (matches && matches.length){
				//$log.log ("Path:" + matches[1]);
				return value;
			}
		
			return "";
		}
	
	}
	
	$scope.getsource = function (szoveg){
		
		if (!$scope.isvideo(szoveg)){
			return;
		}else{
		
			if (!$scope.videoconfigs[szoveg]){
			
				var regExp = /{video}([\s\S]*){\/video}/;
				var matches = regExp.exec(szoveg);
			
				//$scope.pages[i].page_items[j].szoveg = $scope.pages[i].page_items[j].szoveg.replace(/(src=['"])[^'"]*(content[^']*)/g,"$1"+Service.remote_host+"$2");
				//console.log(matches);
			
				if (matches && matches.length){

					var value = matches[1];
					
					//console.log(value);
					//value = value.replace(/^[\s\S]*?(content[^']*)/g,Service.remote_host+"$1");
					value = value.replace(/^[\s\S]*?(content[^']*)/g, "$1");
					//console.log(value);
					
					if (Service.offline){
						var tmpstring = value.replace(/ /g,"%20");
					}else{
						var tmpstring = (Service.remote_host+value).replace(/ /g,"%20");
					}
			
					$scope.videoconfigs[szoveg] = {	
						sources: [
							{src: $sce.trustAsResourceUrl( tmpstring ), type: "video/mp4"}
						],
						theme: (Service.offline ? "" : Service.remote_host) + "bower_components/videogular-themes-default/videogular.css"

					};
				}
			}
		
			return $scope.videoconfigs[szoveg].sources;
		}
	
	}
	
	$scope.config = {
		theme: (Service.offline ? "" : Service.remote_host) + "bower_components/videogular-themes-default/videogular.css",
		plugins: {
			controls: {
				autoHide: true,
				autoHideTime: 0
			}
		}
	};

/* test-code */	
	if ( !Service.valasztottcsomag ){
		//itt
		Message.prepForBroadcast("chooseron");
		$location.path('/chooser');
	}else{
		Message.prepForBroadcast("playon");
		//Service.getpackages(Service.valasztottcsomag);
	}
/* end-test-code */

/* test-code */	
	$scope.visszaallitas100 = function (){
	
		var mysorszam = -1;
		
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){
		
			$scope.items[mysorszam].szelesseg = "100px";
			$scope.items[mysorszam].magassag = "100px";
		
			var myszoveg = $scope.items[mysorszam].szoveg;
			
			myszoveg = myszoveg.replace( /width=['"]\d+px['"]/g ,"width='100px'");
			myszoveg = myszoveg.replace( /height=['"]\d+px['"]/g ,"height='100px'");
			$scope.items[mysorszam].szoveg = myszoveg;
		}
		
		$scope.saveitems();
		$scope.itempositions();
	}
/* end-test-code */

/* test-code */		
	$scope.visszaallitasfull = function (param){
	
		//$log.log (param);
	
		var mysorszam = -1;
		
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){
		
			var regExp = /<img [\s\S]*?src=['"][\s\S]*?(content\/[\s\S]*?)['"][\s\S]*?\/?>(<\/img>)?/;
			var matches = regExp.exec($scope.items[mysorszam].szoveg);
			
			if (matches && matches.length){

				var kulcs = matches[1].replace(/%20/g," ");
			
				var origx = 100;
				var origy = 100;
			
				var regExp2 = /^(\d+\.?\d*)px$/;
				var talalatok = regExp2.exec($scope.items[mysorszam].szelesseg);
				if (talalatok && talalatok.length){
					origx = talalatok[1];
				}
				var talalatok = regExp2.exec($scope.items[mysorszam].magassag);
				if (talalatok && talalatok.length){
					origy = talalatok[1];
				}
				
				if (param == "xhez"){
					$scope.items[mysorszam].magassag = (( origx - 2 * parseInt($scope.items[mysorszam].padding) ) 
														* $scope.sizesarray[kulcs].height/$scope.sizesarray[kulcs].width
														+ 2 * parseInt($scope.items[mysorszam].padding) ) + "px";
				}else if (param=="yhoz"){
					$scope.items[mysorszam].szelesseg = origy / ($scope.sizesarray[kulcs].height/$scope.sizesarray[kulcs].width) + "px";
				}else{		
					$scope.items[mysorszam].szelesseg = $scope.sizesarray[kulcs].width + "px";
					$scope.items[mysorszam].magassag = $scope.sizesarray[kulcs].height + "px";
				}

				var myszoveg = $scope.items[mysorszam].szoveg;
				myszoveg = myszoveg.replace( /<img [\s\S]*?src=['"][\s\S]*?(content\/[\s\S]*?)['"][\s\S]*?\/?>(<\/img>)?/,  
									"<img align='left' width='" + (  parseInt($scope.items[mysorszam].szelesseg) - 2 *  parseInt($scope.items[mysorszam].padding) )
									+ "' height='"+ ( parseInt( $scope.items[mysorszam].magassag) - 2 *  parseInt($scope.items[mysorszam].padding) ) 
									+"' src='" + Service.remote_host + kulcs.replace(/ /g,"%20") + "'></img>");
				$scope.items[mysorszam].szoveg = myszoveg;
				
				$scope.saveitems();
				$scope.itempositions();

			}	
			
		}
		
		
	}
/* end-test-code */
	
	$scope.beirva = function (){
	
	
	}
	
	$scope.isvideo = function (param){
	
		var regex = /\{video\}/;
	
		if ( param != undefined && param.match( regex )){
			return true;
		}else{
			return false;
		}
	}
	
	$scope.ishalmazelem = function ( param ){
		
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.items[i].id == param) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){		
			var myelem = $scope.items[mysorszam];
			if (myelem.kivalasztas == "halmazelem"){
				return true;
			}else{
				return false;
			}
		}
	}
	
	$scope.isanim = function (param){
	
		var regex = /\{animation\}/;
	
		if (param != undefined && param.match( regex )){
			return true;
		}else{
			return false;
		}
	}

/* test-code */	
	$scope.onSelectItemCallback = function ($item, $model){
	
		//console.log ($item);
	
		//$scope.background_selopt_item = $item;
		$scope.itemdata.background_selopt_item = $item;
		$scope.updateitem();
	}
/* end-test-code */	

/* test-code */	
	$scope.unselectall = function (){
	
		if ($scope.adminmode){
		  $scope.setToInitialState();
		  $scope.elemvalasztva = false;
		}
		  
	}
/* end-test-code */	


/* test-code */	
	$scope.onSelectItemselectCallback = function ($item, $model){

		$scope.valasztottelem = undefined;
		$scope.selectBlock($item.id);
	
	}
/* end-test-code */	


/* test-code */	
	$scope.onSelectDisplaystartCallback = function ($item, $model){
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){		
			var myelem = $scope.items[mysorszam];
			myelem.displaystart = parseInt($item.time_title);
			$scope.saveitems();
		}

	}
/* end-test-code */	

/* test-code */	
	$scope.onSelectAnimCallback = function ($item, $model){
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){		
			var myelem = $scope.items[mysorszam];
			myelem.anim = $item.anim_type;
			$scope.saveitems();
		}

	}
/* end-test-code */	

/* test-code */		
	$scope.onSelectDisplayendCallback = function ($item, $model){
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){		
			var myelem = $scope.items[mysorszam];
			myelem.displayend = parseInt($item.time_title);
			$scope.saveitems();
		}

	}	
/* end-test-code */	

/* test-code */	
	$scope.onSelectSablonCallback = function ($item, $model){
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){
			var myelem = $scope.items[mysorszam];
			myelem.template_id = $item.template_id;
			
			if ($item.template_id != ""){
				myelem.szoveg = $item.template_data;
				myelem.magassag = $item.template_embedy + $item.template_embedy_type;
				myelem.szelesseg = $item.template_embedx + $item.template_embedx_type;
			}
			
			$scope.saveitems();
		}

		$scope.gettemplatestyles();
		
		//$log.log($item);
		//$log.log (myelem);
	
	}
/* end-test-code */	

/* test-code */		
	$scope.onSelectStilusCallback = function ($item, $model){
	
		//$log.log($item);
		
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){
			var myelem = $scope.items[mysorszam];
			myelem.style_id = $item.style_id;
			$scope.saveitems();
		}
	
		$scope.gettemplatestyles();
		$scope.getstylestyles();
		$scope.getprivatestyles();
	
	}
/* end-test-code */	

/* test-code */		
	$scope.updateitem = function (event){

		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){

			$scope.itemdata.elemtipus = "normal";
		
			//if ( $scope.background_selopt_item.id.match(/mp4$/)){
			if ( $scope.itemdata.background_selopt_item.type == "video"){
				$scope.items[i].szoveg = "{video}" + Service.remote_host + $scope.itemdata.background_selopt_item.id.replace(/ /g,"%20") + "{/video}";
				$scope.itemdata.elemtipus = "video";
			}else if ($scope.itemdata.background_selopt_item.type == ""){
					$scope.items[i].szoveg = "Töltsd ki!";
			}else if ($scope.itemdata.background_selopt_item.type == "animation") {
				$scope.items[i].szoveg = "";
				$scope.items[i].szoveg = "{animation}" + Service.remote_host + $scope.itemdata.background_selopt_item.id.replace(/ /g,"%20") + "|" + $scope.itemdata.background_selopt_item.xmeret + "|" + $scope.itemdata.background_selopt_item.ymeret +"{/animation}";
				$scope.items[i].szelesseg = $scope.itemdata.background_selopt_item.xmeret;
				$scope.items[i].magassag = $scope.itemdata.background_selopt_item.ymeret;
				$scope.animchange++;
				$scope.itemdata.elemtipus = "animation";
			}else{
			
				if ($scope.itemdata.meret100 == 0){
					
					var mymeretx = 0;
					var mymerety = 0;
					
					var origx = 0;
					var origy = 0;
					
					var regExp2 = /^(\d+\.?\d*)px$/;
					var talalatok = regExp2.exec($scope.items[mysorszam].szelesseg);
					if (talalatok && talalatok.length){
						origx = talalatok[1];
					}
					var talalatok = regExp2.exec($scope.items[mysorszam].magassag);
					if (talalatok && talalatok.length){
						origy = talalatok[1];
					}
					
					var kepmeretarany = $scope.sizesarray[$scope.itemdata.background_selopt_item.id].height / $scope.sizesarray[$scope.itemdata.background_selopt_item.id].width;
					var elemmeretarany = origy/origx;
					
					if ($scope.itemdata.aranyos){
						
						if (kepmeretarany>elemmeretarany){
							//Alul felul elerjuk az elemet
							mymerety = origy;
							mymeretx = mymerety / kepmeretarany;
						}else{
							//oldalt elérjük az elemet
							mymeretx = origx;
							mymerety = mymeretx * kepmeretarany;
						}
						
						mymeretx = mymeretx + "px";
						mymerety = mymerety + "px";
						
						
					}else{
						
						mymeretx = $scope.items[i].szelesseg;
						mymerety = $scope.items[i].magassag;
					}
					
					
					if ($scope.itemdata.kepszoveggel){
						$scope.items[i].szoveg = "<div style='text-align: center;'><img style='text-align: center;' width='" + mymeretx + 
												"' height='" + mymerety + "' src='" + Service.remote_host + $scope.itemdata.background_selopt_item.id.replace(/ /g,"%20") + "'></img></div><p style='text-align: center; clear: left;'><span class='kepszoveg'>Szöveg ide</span></p>";
					}else{
						$scope.items[i].szoveg = "<div  style='float: left;'><img width='" + mymeretx + 
												"' height='" + mymerety + "' src='" + Service.remote_host + $scope.itemdata.background_selopt_item.id.replace(/ /g,"%20") + "'></img></div>";
					}
				}else{
							var xmeret = $scope.sizesarray[$scope.itemdata.background_selopt_item.id].width + "px";
							var ymeret = $scope.sizesarray[$scope.itemdata.background_selopt_item.id].height + "px";
					
							$scope.items[i].szelesseg = xmeret;
							$scope.items[i].magassag = ymeret;
							if ($scope.itemdata.kepszoveggel){
								$scope.items[i].szoveg = "<div style='float: left; padding-right:10px; padding-bottom:10px;'><img align='left' width='" + xmeret + 
												"' height='"+ymeret+"' src='" + Service.remote_host + $scope.itemdata.background_selopt_item.id.replace(/ /g,"%20") + "'></img></div>Szöveg ide";
							}else{
								$scope.items[i].szoveg = "<div  style='float: left;'><img width='" + xmeret + 
												"' height='"+ymeret+"' src='" + Service.remote_host + $scope.itemdata.background_selopt_item.id.replace(/ /g,"%20") + "'></img></div>";
							}
				
				}
				
			}
			$scope.saveitems();

		}

		if ($scope.files.length){
			$scope.itemdata.background_selopt_item = $scope.files[0];
		}
		
		//$scope.meret100 = 0;
		//$scope.kepszoveggel = 0;
		
	}
/* end-test-code */	

/* test-code */		
	$scope.onSelectCommonCallback = function ($item, $model){
		
		$scope.page_commmon_selopt = $item;
		$scope.updatecommon();

	}
/* end-test-code */	
	
/* test-code */		
	$scope.onSelectCallback = function ($item, $model){
	
		//$log.log ($item);
		$scope.background_selopt = $item;
		$scope.updatebkg();
	}
/* end-test-code */	

/* test-code */	
	$scope.onSelectPosterCallback = function ($item, $model){

		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){
			var myelem = $scope.items[mysorszam];
			myelem.poster = $item.id;
			$scope.saveitems();
		}	

	}
/* end-test-code */	
	
	$scope.getitemposter = function (id){
		return( Service.remote_host + id.replace(/ /g,"%20") );
	}

	$scope.hasposter = function (id){
		
		if (id == "" || id == undefined){
			return false;
		}else{
			return true;
		}
	}

/* test-code */	
	$scope.updatecommon = function (event){

		if ($scope.page_common_selopt.id != Service.valasztottlap.page_id){
			$scope.pages[$scope.page_pointer].page_common = $scope.page_common_selopt.id;
		}else{
			$scope.page_common_selopt = $scope.page_common[0];
			$scope.pages[$scope.page_pointer].page_common = "";
		}
				
		var tempobject = angular.copy($scope.pages[$scope.page_pointer]);
		tempobject.page_items = angular.toJson (tempobject.page_items, false);
		Service.updatepage (tempobject);
		
	}
/* end-test-code */	

/* test-code */		
	$scope.updatebkg = function (event){

		$scope.background = Service.remote_host + $scope.background_selopt.id.replace(/ /g,"%20");
		$scope.pages[$scope.page_pointer].page_background = $scope.background_selopt.id;
		$scope.background_orig = $scope.pages[$scope.page_pointer].page_background;
				
		var tempobject = angular.copy($scope.pages[$scope.page_pointer]);
		tempobject.page_items = angular.toJson (tempobject.page_items, false);
		Service.updatepage (tempobject);
	}
/* end-test-code */	
	
	$scope.loadimage = function (param) {
	
		var tmpstring = Service.remote_host+param.replace(/ /g,"%20");
	
        var img = new Image();
		img.id = param;
		
        img.onload = function (param) {
			$scope.sizesarray[img.id] = { width: img.width, height: img.height};
        }
		
        img.src = tmpstring;
    }
	
	$scope.$watch(function () { return Service.files; },function (value) {
	
		if ( value.length == 0 && $scope.fileinit){
			$scope.fileinit = false
			return;
		}
	
		$scope.files = value;
		$scope.bgfiles = [];
		$scope.sizesarray = {}
		
		$scope.videoconfigs = {};
		
		for(var i = 0; i < value.length; i++){

			var patt = /(jpg|png|gif|jpeg)$/i;
		
			if (  patt.test(value[i].id) || value[i].id == "" ){
				$scope.bgfiles.push(value[i]);
			}

			//$log.log (value[i]);
			
			if (  patt.test(value[i].id) ){
				$scope.loadimage(value[i].id);
			}
			
			var tmpstring = Service.remote_host+value[i].id.replace(/ /g,"%20");

		
			if (tmpstring.match(/mp4$/)){
				
				$scope.videoconfigs[ "{video}" + tmpstring + "{/video}"] = {	
					sources: [
						{src: $sce.trustAsResourceUrl( Service.remote_host + value[i].id ), type: "video/mp4"}
					],
					theme:  (Service.offline ? "" : Service.remote_host) + "bower_components/videogular-themes-default/videogular.css"

				};
				
			}
		
			if ( tmpstring == $scope.background){
				$scope.background_selopt = value[i];
			}
			
			if (value[i].id == ""){
				$scope.itemdata.background_selopt_item = value[i];
			}
		}
		
		Service.bgfiles = $scope.bgfiles;
	});	

/* test-code */		
	$scope.$on('colorpicker-closed', function(event, colorObject){
		$scope.pages[$scope.page_pointer].page_background_color = colorObject.value;
		var tempobject = angular.copy($scope.pages[$scope.page_pointer]);
		tempobject.page_items = angular.toJson (tempobject.page_items, false);
		Service.updatepage (tempobject);
		
	});
/* end-test-code */	
	
	$scope.pagejump = function(id){
		
		var mypointer = 0;
		var pointerorig = $scope.page_pointer;
		var talalat = false;
		
		for (var i = 0, len = $scope.pages.length; i < len; i++) {
			if ($scope.pages[i].page_id == id){
				talalat = true;
				break;
			}
			mypointer++
		}

		 
		
		if ( talalat && $scope.checkdeps($scope.page_pointer) && mypointer != $scope.page_pointer){

		
			$scope.pageturn = true;
			//$log.log ("Lapozás folyamatban");		
			$scope.page_pointer = mypointer;


			//Valódi lapszámozás
			$scope.page_pointer_real = 0;
			for (var i = 0, len = $scope.pages.length; i < len; i++) {
				if ($scope.pages[i].page_hidden!="1"){
						$scope.page_pointer_real++;
				}
				if ( i == $scope.page_pointer){
						break;
				}
			}


			$scope.initpage();
		
		}else{
			$scope.page_pointer = pointerorig;
		}
			
	}
	
	$scope.pageleft = function(){
		
			//$window.goBack();

			if ($scope.adminmode){
				if ($scope.page_pointer > 0){
					$scope.page_pointer--;
				}
			}else{
				var talalat = false;
				var pointerorig = $scope.page_pointer;
				
				while ( !talalat && $scope.page_pointer > 0 ) {
					$scope.page_pointer--;
					if ($scope.pages[$scope.page_pointer].page_hidden!="1"){
						talalat = true;
					}
				}

				if (!talalat || !$scope.checkdeps($scope.page_pointer) ){
					$scope.page_pointer = pointerorig;
					return;
				}
			}

			//Valódi lapszámozás
			$scope.page_pointer_real = 0;
			for (var i = 0, len = $scope.pages.length; i < len; i++) {
				if ($scope.pages[i].page_hidden!="1"){
						$scope.page_pointer_real++;
				}
				if ( i == $scope.page_pointer){
						break;
				}
			}
			
			$scope.pageturn = true;
			//$log.log ("Lapozás folyamatban");
					
			$scope.initpage();
	}

	$scope.pageright = function(){
		
			//$window.goForward();
			
			if ($scope.adminmode){
				if ($scope.page_pointer < $scope.pages.length-1){
					$scope.page_pointer++;
				}
			}else{
				var talalat = false;
				var pointerorig = $scope.page_pointer;
				
				while ( !talalat && $scope.page_pointer < $scope.pages.length-1 ) {
					$scope.page_pointer++;
					if ($scope.pages[$scope.page_pointer].page_hidden!="1"){
						talalat = true;
					}
				}
				
				if (!talalat || !$scope.checkdeps($scope.page_pointer)){
					$scope.page_pointer = pointerorig;
					return;
				}
			}				

			//Valódi lapszámozás
			$scope.page_pointer_real = 0;
			for (var i = 0, len = $scope.pages.length; i < len; i++) {
				if ($scope.pages[i].page_hidden!="1"){
						$scope.page_pointer_real++;
				}
				if ( i == $scope.page_pointer){
						break;
				}
			}
			
			$scope.pageturn = true;
			//$log.log ("Lapozás folyamatban");			
			$scope.initpage();
	}

/* test-code */	
	$scope.backtopackages = function (){
		Service.valasztottcsomag = "";
		Message.prepForBroadcast("chooseron");
		$location.path('/chooser');
	}

	$scope.backtopages = function (){
		Message.prepForBroadcast("chooseron");
		$location.path('/chooser');
	}
/* end-test-code */	
	
	$scope.processprogress = function (){
		for(var i = 0; i < $scope.pages.length; i++){			
			$scope.progress[$scope.pages[i].page_id] = false;
		}
	}
	
	$scope.$watch(function () { return Service.pages; },function (value) {
		
		if ($scope.package_selected == ""){
			return;
		}
		var mydata = value;
		for(var i = 0; i < mydata.length; i++){
			mydata[i].page_order = parseInt( mydata[i].page_order, 10);
		}	
		$scope.pages = mydata;
		$scope.progress = [];
		$scope.processprogress();

		if ( !$scope.pages.length){
			if (!Service.playermode){
				Message.prepForBroadcast("chooseron");
				$location.path('/chooser');
				return;
			}else{
				return;				
			}
		}

		//Valódi lapszámozás létrehozása
		$scope.pagesall=0;
		for(var i = 0; i < $scope.pages.length; i++){
			if ($scope.pages[i].page_hidden!="1" ){
				$scope.pagesall++;
			}
		}
		
		//Lap betöltése innen
		$scope.page_pointer = 0;
		if (Service.valasztottlap != ""){
			for(var i = 0; i < $scope.pages.length; i++){
				if ($scope.pages[i].page_id == Service.valasztottlap){
					$scope.page_pointer = i;
				}
			}
		}else{
			Service.valasztottlap = $scope.pages[$scope.page_pointer];
		}

		$scope.initpage("init");
	});	
	
    $scope.$watch(function () { return Service.packages; },function (value) {

		var mydata = value;
		
		for(var i = 0; i < mydata.length; i++){
			mydata[i].package_order = parseInt( mydata[i].package_order, 10);
			mydata[i].package_width = parseInt( mydata[i].package_width, 10);
			mydata[i].package_height = parseInt( mydata[i].package_height, 10);
			
			if (mydata[i].package_id == Service.valasztottcsomag){
				$scope.package = mydata[i];
				$scope.package_selected = mydata[i].package_id;
				$scope.package_selected_title = mydata[i].package_title;
				$scope.packagestyles = $scope.package.package_style;
				
				if (Service.offline){
						$scope.packagestyles = $scope.packagestyles.replace(/\.\.\/content/g,"content");
						$scope.packagestyles = $scope.packagestyles.replace(/\/content/g,"content");
				}else{
					$scope.packagestyles = $scope.packagestyles.replace(/url[^\(\)]*?\([^\(\)]*?(content[^\(\)]*?)\)/g,"url("+Service.remote_host+"$1)");
					//console.log($scope.packagestyles);
				}
			}
			
		}

		if ($scope.package.package_id != ""){
			Service.getpages($scope.package_selected);
			//Service.getres($scope.package_selected);			
		}else{
			Message.prepForBroadcast("chooseron");
			$location.path('/chooser');
		}
		
	});


/* test-code */		
	$scope.updateitemanimonexit = function(){
		
		$scope.pages[$scope.page_pointer].page_itemanimonexit=$scope.itemanimonexit;
		$scope.pages[$scope.page_pointer].page_items = angular.toJson($scope.items);
		Service.updatepage($scope.pages[$scope.page_pointer]);

	}
/* end-test-code */

/* test-code */	
	$scope.updatecommontofront = function(){
		
		$scope.pages[$scope.page_pointer].page_common_tofront=$scope.commontofront;
		$scope.pages[$scope.page_pointer].page_items = angular.toJson($scope.items);
		Service.updatepage($scope.pages[$scope.page_pointer]);

	}
/* end-test-code */	

/* test-code */		
	$scope.updatepagetitle = function(){
		
		$scope.pages[$scope.page_pointer].page_title=$scope.cim;
		
		$scope.pages[$scope.page_pointer].page_items = angular.toJson($scope.items);
		
		Service.updatepage($scope.pages[$scope.page_pointer]);

	}
/* end-test-code */	
	
	$scope.checkdeps = function(pointer){
		
		if  ( $scope.pages[pointer] != undefined ){
			
			//Már teljesítve volt
			if ( $scope.progress[$scope.pages[pointer].page_id]){
				return true;
			}
			
			var fuggosegek = $scope.cleanstring ($scope.pages[pointer].page_dependencies);
			var lapok = '';
			
			for (var i = 0, len = fuggosegek.length; i < len; i++) {
				var lap = $scope.getpagebyalias(fuggosegek[i]);
				if ( lap !=undefined && !$scope.progress[lap.page_id] ){
					if (lapok!='') lapok += ", ";
					lapok += lap.page_title;
				}
			}
			
			//$window.alert(greeting);
			if (lapok){
				window.alert ("A lap megtekintéséhez a " + lapok + " lapok megtekintése kötelező.");
				return false;
			}else{
				return true;
			}
		}else{
			return false;
		}
		
		
	}
	
	$scope.checkpackagedone = function (){
		
		var megvan = true;
		
		for (var i = 0, len = $scope.pages.length; i < len; i++) {
			
			if ( $scope.pages[i].page_telj == '1' ){
				
				if ( !$scope.progress[$scope.pages[i].page_id]){
					megvan=false;
					break;
				}
				
			}

		}
		
		if (megvan){
			//$log.log ("Csomag kész");
		}
		
	}

	$scope.setpagevisited = function( param){
		
		//$log.log ("Teljesítetted:" + param.id);
		$scope.progress[ param.id ] = true;
		$scope.checkpackagedone();
		
	}
	
	$scope.clearcanvas = function (){	
	
		$scope.rajzparok = [];
	
		var c=document.getElementById("myCanvas");
		if (c){
			var ctx=c.getContext("2d");
			ctx.clearRect(0, 0, c.width, c.height);
		}
	}
	
	$scope.initpage = function ( param ){
	
		//console.log ($scope.pages[$scope.page_pointer].page_alias);
		if ( $scope.pages[$scope.page_pointer].page_alias=="scormend" ){
			//console.log ("SCORM vége");
			if ( typeof $window.scormend !== "undefined"){
				$window.scormend();
			}
		}
	
		$scope.clearcanvas();
	
		//Töröljük az elemanimációkat
		for (var i = 0, len = $scope.timertasks.length; i < len; i++) {
				$interval.cancel($scope.timertasks[i]);
		}
		
		//Megszakítjuk a laptelejsítés időzítést is
		$interval.cancel($scope.progresstimer);
		$scope.progresstimer = 0;
		
		$scope.timertasks = [];
		$scope.itemvisibilities = [];
		$scope.videoloading = true;
	
		$scope.xmeret = $scope.package.package_width + $scope.package.package_width_type;
		$scope.ymeret = $scope.package.package_height + $scope.package.package_height_type;

		$scope.xmeret_num = $scope.package.package_width;
		$scope.ymeret_num = $scope.package.package_height;
		
		$scope.cim = $scope.pages[$scope.page_pointer].page_title;
		$scope.id = $scope.pages[$scope.page_pointer].page_id;
		$scope.cimlathato = true;
		
		$scope.background = Service.remote_host + $scope.pages[$scope.page_pointer].page_background;
		
		if (Service.offline){
				$scope.background = $scope.pages[$scope.page_pointer].page_background;
		}else{
				$scope.background = Service.remote_host + $scope.pages[$scope.page_pointer].page_background;
		}
		
		$scope.background = $scope.background.replace(/ /g,"%20");
		$scope.background_color = $scope.pages[$scope.page_pointer].page_background_color;
		
		$scope.background_orig = $scope.pages[$scope.page_pointer].page_background;
		
		//$scope.page_common = [{id:"", name:"Válasszon"}];
		$scope.page_common = [{id:"", name:"Nincs"}];
		$scope.page_common_selopt = $scope.page_common[0];
		
		var commonitems = [];
		
		for (var i = 0, len = $scope.pages.length; i < len; i++) {
			
			var tempobject = {id:$scope.pages[i].page_id, name:$scope.pages[i].page_title};
			$scope.page_common.push(tempobject);

			if ( $scope.pages[i].page_items != ""){
				$scope.pages[i].page_items = angular.fromJson($scope.pages[i].page_items);
			}else{
				$scope.pages[i].page_items = [];
			}
			
			//csere itt
			for (var j = 0, lenj = $scope.pages[i].page_items.length; j < lenj; j++) {
				
				if ($scope.pages[i].page_items[j].szoveg){
					//console.log ("szöveg:" + $scope.pages[i].page_items[j].szoveg);
					//console.log( $scope.pages[i].page_items[j].szoveg.replace(/(src=['"])[^'"]*(content[^']*)/g,"$1"+Service.remote_host+"$2") );
					if (!Service.offline){
						$scope.pages[i].page_items[j].szoveg = $scope.pages[i].page_items[j].szoveg.replace(/(src=['"])[^'"]*?(content[^'"]*)/g,"$1"+Service.remote_host+"$2");
					}
					//console.log ("Új szöveg:" + $scope.pages[i].page_items[j].szoveg);
				}
			}		

			if ( $scope.pages[i].page_id == $scope.pages[$scope.page_pointer].page_common){
				$scope.page_common_selopt = angular.copy(tempobject);
				angular.copy( $scope.pages[i].page_items, commonitems );
			}
			
		}	
		
		if ( $scope.pageturn && $scope.itemanimonexit==0 && $scope.items.length){
			$animate.enabled(false);
			$scope.items = [];
			$scope.itemvisibilities =[];
			$interval( $scope.initpage, '10', 1, true);
			return;
		}
		$animate.enabled(true);

		
		//Ha nincs időzítés, akkor teljesítve a lap
		if ( !$scope.progress[$scope.pages[$scope.page_pointer].page_id] ){
			if ($scope.pages[$scope.page_pointer].page_viewtimer == '0'){
				$scope.setpagevisited ({id:$scope.pages[$scope.page_pointer].page_id});
			}else{
				$scope.progresstimer = $interval( $scope.setpagevisited, parseInt($scope.pages[$scope.page_pointer].page_viewtimer)*1000 , 1, true, {id:$scope.pages[$scope.page_pointer].page_id});
			}
		}
		
		$scope.items = [];
		$scope.itemvisibilities =[];
		var pageitems = [];
		
		$scope.pageturn = false;
		
		angular.copy( $scope.pages[$scope.page_pointer].page_items, pageitems);
		
		$scope.itemanimonexit = parseInt($scope.pages[$scope.page_pointer].page_itemanimonexit);
		$scope.commontofront = parseInt($scope.pages[$scope.page_pointer].page_common_tofront);

		
		if ( commonitems.length && !$scope.adminmode ){
			if ( $scope.commontofront ){
				$scope.items = pageitems.concat(commonitems);
			}else{
				$scope.items = commonitems.concat(pageitems);			
			}
		}else{
			$scope.items = pageitems;
		}
		
		 angular.copy( $scope.items, $scope.origitems);
		
		//$scope.$apply();
		
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			$scope.itemvisibilities[$scope.items[i].id] = true;
			
			if ($scope.items[i].kivalasztas == "osszekotos" ){
				$scope.items[i].psel = false;
				$scope.items[i].pelem = true;
			}
			
			if ( !isNaN($scope.items[i].visibleonstart) &&  !$scope.items[i].visibleonstart && !$scope.adminmode ){
				$scope.itemvisibilities[$scope.items[i].id] = false;
			}
			
			if ( !isNaN($scope.items[i].displaystart) &&  $scope.items[i].displaystart>0 && !$scope.adminmode ){
				$scope.timertasks.push ($interval( $scope.visibilitycallback, $scope.items[i].displaystart, 1, true, {task: "start", id:$scope.items[i].id, num:i}));
				$scope.itemvisibilities[$scope.items[i].id] = false;
			}

			if ( !isNaN($scope.items[i].displayend) &&  $scope.items[i].displayend>0 && !$scope.adminmode ){
				$scope.timertasks.push ($interval( $scope.visibilitycallback, $scope.items[i].displayend, 1, true, {task: "end", id:$scope.items[i].id, num:i}));
			}

			
		}	
		
		$scope.isSelected = {};
		$scope.elemvalasztva = false;
		
		$scope.itemdata.background_selopt_item = {};
		
		Service.getres($scope.package_selected);
		
		$scope.getprivatestyles();
		$scope.gettemplatestyles();
		$scope.getstylestyles();
		
		Service.getstyles(Service.valasztottcsomag);
		Service.gettemplates(Service.valasztottcsomag);
		
		$scope.loading = false;
		/*
			   $AdobeEdge.loadComposition('/content/edge/111/111dia', 'EDGE-871251114', {
				scaleToFit: "none",
				centerStage: "none",
				minW: "0px",
				maxW: "undefined",
				width: "785px",
				height: "445px"
			}, {"dom":{}}, {"dom":{}});
		*/
		
		$scope.times = [ ];
		for( var i = 0; i < 200; i++){
				$scope.times.push( { "time_id": i, "time_title": i*500  }  );
		}
		
		/*
		var c=document.getElementById("myCanvas");
		var ctx=c.getContext("2d");
		ctx.beginPath();
		ctx.moveTo(0,0);
		ctx.lineTo( 100, 100 );
		ctx.lineTo( 500, 200 );
		ctx.lineTo( 500, 500 );
		ctx.lineTo( 200, 500 );
		ctx.lineTo( 100, 100 );
		ctx.stroke();
		*/
		
		//console.log($scope.items);
		
		if (typeof $window.initpagecustom === "function") { 
					$window.initpagecustom();
					console.log ("initpagecustom");
		}
		
	}

	$scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
		if (typeof MathJax !== 'undefined') {
			MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
		}
	});
	
	$scope.visibilitycallback = function( params ){
		if (!$scope.adminmode){	
			if (params.task =="start"){
				$scope.itemvisibilities[params.id] = true;
			}else if (params.task =="end"){
				$scope.itemvisibilities[params.id] = false;
			}
		}
	}

/* test-code */		
	$scope.hozzaadas = function (){
		var id = Service.guid();
		$scope.items.push (  
				{	
					"anim": "",
					"autohide": 0,
					"autoplay": "0",
					"displayend": "0",
					"displaystart": "0",
					"id": id, 
					"jumpid":"", "nagyszoveg":"", 
					"magassag":"100px", 				
					"magnify":"hidden", 
					"nagyszoveg": "",
					"overflow":"hidden", 
					"padding":"0px",
					"poster": "",				
					"posx":"10px", 
					"posy":"10px", 
					"style_id": "", 
					"style_data": "",					
					"szelesseg":"100px", 
					"szoveg": "Töltsd ki!", 
					"template_id": "", 
					'videobuttons': "0",
					'visibleonstart': 1,
					'itemname': "",
					'showitemsclick': "",
					'hideitemsclick': "",
					'mouseover': "",
					'showitemsover': "",
					'hideitemsleave': "",
					'kivalasztas': "",
					'behuz': "0",
					'kivalasztasg': "",
					'kivalasztast': ""
					});
		$scope.saveitems();
		$scope.selectBlock(id);
	}
/* end-test-code */	

/* test-code */
	$scope.saveitems = function(){
	
		$scope.pages[$scope.page_pointer].page_items = $scope.items;
		Service.saveitems($scope.package_selected, $scope.id, $scope.items); 
	
	}
/* end-test-code */

	$scope.hoverIn = function (id) {
	
		var mysorszam = -1;
		
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ( $scope.items[i].id == id) {
				mysorszam = i;
				break;
			}
		}

		if ( $scope.items[mysorszam].mouseover == "visible" ){
			$scope.showbyname ( $scope.cleanstring ($scope.items[mysorszam].showitemsover) );
		}
		
		
		
	}

	$scope.hoverOut = function (id) {
	
		var mysorszam = -1;
		
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ( $scope.items[i].id == id) {
				mysorszam = i;
				break;
			}
		}

		if ( $scope.items[mysorszam].mouseover == "visible" ){
			$scope.hidebyname ( $scope.cleanstring ($scope.items[mysorszam].hideitemsleave) );
		}
		
	}
	
	$scope.showbyname = function (name){
		
		for (var i = 0; i < name.length; i++)
        {
			
			var invertalt = false;
			
			var keresett = name[i];
			if (keresett.substring(0,1) == "!"){
				invertalt = true;
				keresett = keresett.substring(1);
			}
			
			for (var j = 0, len = $scope.items.length; j < len; j++) {
				if ( $scope.items[j].itemname == keresett && keresett!="") {
					if (invertalt){
						$scope.itemvisibilities[$scope.items[j].id] = false;
					}else{
						$scope.itemvisibilities[$scope.items[j].id] = true;
					}
					break;
				}
			}
			
        }
	}
	
	$scope.hidebyname = function (name){
		
		for (var i = 0; i < name.length; i++)
        {

			var invertalt = false;
			var keresett = name[i];
			if (keresett.substring(0,1) == "!"){
				invertalt = true;
				keresett = keresett.substring(1);
			}
			
			for (var j = 0, len = $scope.items.length; j < len; j++) {
				if ( $scope.items[j].itemname == keresett && keresett != "") {
					if (invertalt){
						$scope.itemvisibilities[$scope.items[j].id] = true;
					}else{
						$scope.itemvisibilities[$scope.items[j].id] = false;
					}
					break;
				}
			}
			
        }
	}
	
	$scope.cleanstring = function (string){
		
		var tomb = [];
		
		if (string.trim()==''){
			return tomb;
		}
		
        tomb = string.split(' ');
        for (var i = 0; i < tomb.length; i++)
        {
            tomb[i] = tomb[i].trim();
        }
        return tomb;
	}
	
	$scope.nagyit = function (size, id) {

		//Külső kapcsolat lehetősége
		if (id){
		    var tmpitem = $scope.getselected(id);
			if (tmpitem != -1){tmpitem = $scope.items[tmpitem];}
		    if ( (typeof tmpitem === "object") && (tmpitem !== null) && (typeof $window.customclick === "function")  ) { 
				$window.customclick(tmpitem);
			}
		}
		
		var mysorszam = -1;
		var szoveg = "";
		var title = "";
		
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ( $scope.items[i].id == id) {
				mysorszam = i;
				break;
			}
		}

		if ( $scope.isanim ($scope.items[mysorszam].szoveg) || $scope.isvideo ($scope.items[mysorszam].szoveg)){
			return;
		}
		
		if ( mysorszam == -1){
			return;
		} 

		if ($scope.items[mysorszam].magnify == "visible" || $scope.items[mysorszam].magnify == "picture" ){
		
			if ($scope.items[mysorszam].magnify == "visible"){
				if ($scope.items[mysorszam].nagyszoveg){
					szoveg = $scope.items[mysorszam].nagyszoveg.replace(/\\"/g,'"');
				}else{
					szoveg = $scope.items[mysorszam].szoveg.replace(/\\"/g,'"');				
				}
			} 
		
			if ( $scope.items[mysorszam].magnify == "picture" ){
			
				var regExp = /<img [\s\S]*?src=['"]([\s\S]*?)['"][\s\S]*?\/?>(<\/img>)?/;
				var matches;
				if ($scope.items[mysorszam].nagyszoveg){
					matches = regExp.exec($scope.items[mysorszam].nagyszoveg);
				}else{
					matches = regExp.exec($scope.items[mysorszam].szoveg);
				}
				
				if (matches && matches.length){
					szoveg = ""; //"<img style='max-width:90%; max-height:80%; height:auto;' src='" + matches[1] + "' ></img>";
					szoveg = "<img class='csakkep' src='" + matches[1] + "' ></img>";
				}	
				
			}
		
			if ( $scope.items[mysorszam].nagycim ){
				title = $scope.items[mysorszam].nagycim;
			}else{
				title = "&nbsp;"; //"Nagyítás";
			}
			
			var modalInstance = $uibModal.open({
					  animation: $scope.animationsEnabled,
					  templateUrl: 'Nagyitasablak.html',
					  controller: 'MagnifyInstanceCtrl',
					  windowClass: 'modal-fit',
					  size: size,
					  resolve: {
						mytext: function () {
						
							if (mysorszam!=-1){
								//console.log (szoveg);
								return szoveg;
							}else{
								return "";
							}
						},
						mytitle: function () {
								return title;
						}
					}
			});
			
			modalInstance.result.then(function (mytext) {

			}, function () {
			  //$log.info('Modal dismissed at: ' + new Date());
			});
		}else if ( $scope.items[mysorszam].magnify == "jump" && $scope.items[mysorszam].jumpid ){
			$scope.pagejump($scope.items[mysorszam].jumpid);
		}else if ($scope.items[mysorszam].magnify == "click"){
			$scope.showbyname ( $scope.cleanstring ($scope.items[mysorszam].showitemsclick) );
			$scope.hidebyname ( $scope.cleanstring ($scope.items[mysorszam].hideitemsclick) );
		}else if ($scope.items[mysorszam].magnify == "test"){

			if ( $scope.items[mysorszam].kivalasztas == "ujra"){

			    /*
				for (var i = 0, len = $scope.items.length; i < len; i++) {
					$scope.items[i].testselected = false;
					if ($scope.items[i].kivalasztas == "eredmeny"){
						$scope.itemvisibilities[$scope.items[i].id] = false;
					}
				}
				$scope.clearcanvas();
				angular.copy( $scope.origitems, $scope.items);
				*/
				//$scope.initpage();
				
				if (typeof $window.initcustom === "function") { 
					$window.initcustom();
					console.log ("initcustom");
				}else{
					$scope.initpage();
					console.log ("initpage");
				}
				
				$route.reload();
			}
			
			if ( $scope.items[mysorszam].kivalasztas == "egyszeres"){
				
				var csoportom = $scope.items[mysorszam].kivalasztasg;
				var jovalasz = ( $scope.items[mysorszam].kivalasztast == "yes" );
				
				for (var i = 0, len = $scope.items.length; i < len; i++) {
					if ( $scope.items[i].kivalasztasg == csoportom) {
						$scope.items[i].testselected = false;
						
						if ($scope.items[i].kivalasztas == "eredmeny"){
							if (jovalasz && $scope.items[i].kivalasztast == 'yes' || !jovalasz && $scope.items[i].kivalasztast == 'no'){
								$scope.itemvisibilities[$scope.items[i].id] = true;
							}else{
								$scope.itemvisibilities[$scope.items[i].id] = false;
							}
						}
						
					}
				}
				
				$scope.items[mysorszam].testselected = true;
				
			}

			if ($scope.items[mysorszam].kivalasztas == "osszekotos" ){
				$scope.items[mysorszam].psel = !$scope.items[mysorszam].psel;
				$scope.items[mysorszam].pelem = true;
			}
			
			if ($scope.items[mysorszam].kivalasztas == "tobbszoros" ){
				
				var csoportom = $scope.items[mysorszam].kivalasztasg;
				if ( $scope.items[mysorszam].testselected == true ){
					$scope.items[mysorszam].testselected = false;
				}else{
					$scope.items[mysorszam].testselected = true;
				}
				
				for (var i = 0, len = $scope.items.length; i < len; i++) {
					if ( $scope.items[i].kivalasztasg == csoportom && $scope.items[i].kivalasztas == "eredmeny") {
							$scope.itemvisibilities[$scope.items[i].id] = false;
					}
				}
				
				
			}	
			
			if ($scope.items[mysorszam].kivalasztas == "testcheck"){
				
				//Kiválasztások ellenőrzése
				
				var csoportom = $scope.items[mysorszam].kivalasztasg;
				var mindjo = true;
				
				var csoportjaim = $scope.cleanstring(csoportom);
				
				var halmazok=[];
				
				for (var i = 0, len = $scope.items.length; i < len; i++) {
					//Halmazok keresése
					if ( csoportjaim.indexOf ($scope.items[i].kivalasztasg.trim()) != -1 && $scope.items[i].kivalasztas == "halmaz") {
							halmazok[$scope.items[i].kivalasztasg] = i;
					}
				}
				
				//Összekötős ellenőrzése
				//Ami meg van húzva, jó-e-
				for (var i = 0, len = $scope.rajzparok.length; i < len; i++) {	
					var elem1 = $scope.items[$scope.rajzparok[i][0]];
					var elem2 = $scope.items[$scope.rajzparok[i][1]];
					
					if ( csoportjaim.indexOf (elem2.kivalasztasg.trim()) == -1 && csoportjaim.indexOf (elem1.kivalasztasg.trim()) == -1 ){
						continue;
					}
					
					if (elem1.kivalasztasg == elem2.kivalasztasg && elem1.kivalasztas == "osszekotos" && elem2.kivalasztas == "osszekotos" ){
						
					}else{
						mindjo = false;
						break;
					}
					
				}	
				//Ami kell, meg van-e húzva
				var rajzparsum = [];
				for (var i = 0, len = $scope.items.length; i < len; i++) {
					if ( csoportjaim.indexOf ($scope.items[i].kivalasztasg.trim()) != -1 && $scope.items[i].kivalasztas == "osszekotos" ){
						
						var csoportnev = $scope.items[i].kivalasztasg.trim();
						
						if ( csoportnev in rajzparsum  == false){
							rajzparsum [csoportnev] = [];
						}
						
						if ( rajzparsum [csoportnev].length < 2 ){
							rajzparsum [csoportnev].push (i);
						}
						
					}
				}
				
				//for (var i = 0, len = rajzparsum.length; i < len; i++) {
					
				for (var kulcs in rajzparsum) {
					
					var bennevan = false;
					
					for (var j = 0, len2 = $scope.rajzparok.length; j < len2; j++) {
						if ( rajzparsum[kulcs].indexOf ( $scope.rajzparok[j][0]) != -1  && rajzparsum[kulcs].indexOf ( $scope.rajzparok[j][0]) != -1  ){
							bennevan = true;
							break;
						}
					}
					
					if (!bennevan){
						mindjo=false;
						break;
					}
					
					
				}
				
				//Többszörös ellenőrzése
				for (var i = 0, len = $scope.items.length; i < len; i++) {
					//if ( $scope.items[i].kivalasztasg == csoportom && $scope.items[i].kivalasztas == "tobbszoros") {
					if ( csoportjaim.indexOf ($scope.items[i].kivalasztasg) != -1 && $scope.items[i].kivalasztas == "tobbszoros") {
						
						var jovalasz = ( $scope.items[i].kivalasztast == "yes" );
						
						if (jovalasz && $scope.items[i].testselected == true || !jovalasz && $scope.items[i].testselected == false){
							
						}else{
							mindjo = false;
							break;
						}
					}
					
					//Elemek keresése és ellenőrzése
					if (  $scope.items[i].kivalasztas == "halmazelem"){

						var johelyen = false;

						var elemcsoportok = $scope.cleanstring($scope.items[i].kivalasztasg);
						var csoportja = false;
						for (var j = 0, len2 = elemcsoportok.length; j < len2; j++) {
								if ( elemcsoportok[j] in halmazok  != false){
									//Itt nézem a jókat
									csoportja = true;
									if (  halmazok[elemcsoportok[j]] && $scope.utkozes ( halmazok[elemcsoportok[j]], i ) ){
										johelyen = true;
										break;
									}
								}
						}

						if (!csoportja){
							
							for (var key in halmazok) {
									if ( $scope.utkozes ( halmazok[key], i ) ){
										mindjo = false;
										break;
									}
							}
							
						}
						
						if (!johelyen && csoportja) mindjo = false;
					}
					
					if (!mindjo) break;
				}
				
				
				for (var i = 0, len = $scope.items.length; i < len; i++) {

					//Eredmenykijelzes
					if (  csoportjaim.indexOf ($scope.items[i].kivalasztasg) != -1 && $scope.items[i].kivalasztas == "eredmeny") {
						if ( mindjo && $scope.items[i].kivalasztast == 'yes' || !mindjo && $scope.items[i].kivalasztast == 'no'){
							$scope.itemvisibilities[$scope.items[i].id] = true;
						}else{
							$scope.itemvisibilities[$scope.items[i].id] = false;
						}
					}
				}
				
			}
			
			if ($scope.items[mysorszam].kivalasztas == "osszekotos"){
				
				var osszekotendo = 0;
				var osszekotendok = [];

				for (var i = 0, len = $scope.items.length; i < len; i++) {

					if ($scope.items[i].psel){
						osszekotendo++;
						osszekotendok.push(i);
					}					
				}

				if (osszekotendo == 2){
					$scope.osszekot (osszekotendok);
					for (var i = 0, len = $scope.items.length; i < len; i++) {
						$scope.items[i].psel = false;
					}
				}
				

			}
			
		}else{
			 return;
		}
	};
	
	$scope.vonalhuzas = function ( par ){
		
		var elem1 = $scope.items[par[0]];
		var elem2 = $scope.items[par[1]];
		
    /**
     * Gets styles by a classname
     * 
     * @notice The className must be 1:1 the same as in the CSS
     * @param string className_
     */
    function getStyle(className_) {

        var styleSheets = window.document.styleSheets;
        var styleSheetsLength = styleSheets.length;
        for(var i = 0; i < styleSheetsLength; i++){
            var classes = styleSheets[i].rules || styleSheets[i].cssRules;
            if (!classes)
                continue;
            var classesLength = classes.length;
            for (var x = 0; x < classesLength; x++) {
                if (classes[x].selectorText == className_) {
                    var ret;
                    if(classes[x].cssText){
                        ret = classes[x].cssText;
                    } else {
                        ret = classes[x].style.cssText;
                    }
                    if(ret.indexOf(classes[x].selectorText) == -1){
                        ret = classes[x].selectorText + "{" + ret + "}";
                    }
                    return ret;
                }
            }
        }

    }
	
	var mystyle = getStyle('.pvonal');

	  var vonalvastagsag = 1;
	  var vonalszin = "black";
	
      mystyle = ".pvonal { border-width: 3px; border-color: white; }";
      var result = mystyle.match(/border-width:\s+([\s\S]+?)px;/);
	  if (result != null){
			vonalvastagsag = result[1];
	  }
	
	  var result = mystyle.match(/border-color:\s+([\s\S]+?);/);
	  if (result != null){
			vonalszin = result[1];
	  }	
		
		var c=document.getElementById("myCanvas");
		var ctx=c.getContext("2d");
		
		//Szín
		ctx.strokeStyle = vonalszin;
		
		//Vonalvastagság
		ctx.lineWidth = vonalvastagsag;
		
		ctx.beginPath();
		
		//Számoljunk középpontokat és dőlésszöget.
		
		var pos1x = parseInt($scope.getpxvalue(elem1.posx));
		var szel1 = parseInt($scope.getpxvalue(elem1.szelesseg));
		var pos1y = parseInt($scope.getpxvalue(elem1.posy));
		var mag1 = parseInt($scope.getpxvalue(elem1.magassag));
		
		var koz1x =  pos1x + szel1/2;
		var koz1y =  pos1y+ mag1/2;
		
		var pos2x = parseInt($scope.getpxvalue(elem2.posx));
		var szel2 = parseInt($scope.getpxvalue(elem2.szelesseg));
		var pos2y = parseInt($scope.getpxvalue(elem2.posy));
		var mag2 = parseInt($scope.getpxvalue(elem2.magassag));
		
		var koz2x =  pos2x + szel2/2;
		var koz2y =  pos2y + mag2/2;

		//4|1
		//---
		//3|2


		var honnanx, honnany, hovax, hovay;


		if (koz2x > koz1x){
			//Jobbra esik
			if (koz2y>koz1y){
				//2. negyed
				if ( koz2x-koz1x > koz2y-koz1y){
					//x tengely mellett
					honnanx = pos1x + szel1; honnany = pos1y+mag1/2; hovax = pos2x; hovay = pos2y+mag2/2;
				}else{
					//y tengely mellett
					honnanx = pos1x + szel1/2; honnany = pos1y+mag1; hovax = pos2x+szel2/2; hovay = pos2y;
				}
			}else{
				//1. negyed
				if ( koz2x-koz1x > koz1y-koz2y){
					//x tengely mellett
					honnanx = pos1x + szel1; honnany = pos1y+mag1/2; hovax = pos2x; hovay = pos2y+mag2/2;
				}else{
					//y tengely mellett
					honnanx = pos1x + szel1/2; honnany = pos1y; hovax = pos2x+szel2/2; hovay = pos2y+mag2;
				}
			}
		}else{
			//balra esik
			if (koz2y>koz1y){
				//3. negyed
				if ( koz1x-koz2x > koz2y-koz1y){
					//x tengely mellett
					honnanx = pos1x; honnany = pos1y+mag1/2; hovax = pos2x+szel2; hovay = pos2y+mag2/2;
				}else{
					//y tengely mellett
					honnanx = pos1x + szel1/2; honnany = pos1y + mag1; hovax = pos2x+szel2/2; hovay = pos2y;
				}
			}else{
				//4. negyed
				if ( koz1x-koz2x > koz1y-koz2y){
					//x tengely mellett
					honnanx = pos1x; honnany = pos1y+mag1/2; hovax = pos2x+szel2; hovay = pos2y+mag2/2;
				}else{
					//y tengely mellett
					honnanx = pos1x+szel1/2; honnany = pos1y; hovax = pos2x+szel2/2; hovay = pos2y+mag2;
				}
			}
		}

		ctx.moveTo( honnanx, honnany);
		ctx.lineTo ( hovax, hovay );

		/*
		if (  parseInt($scope.getpxvalue(elem1.posx)) < parseInt($scope.getpxvalue(elem2.posx)) ){
			ctx.moveTo(  parseInt($scope.getpxvalue(elem1.posx)) +  parseInt($scope.getpxvalue(elem1.szelesseg)) , parseInt($scope.getpxvalue(elem1.posy)) + parseInt($scope.getpxvalue(elem1.magassag))/2 );
			ctx.lineTo( parseInt($scope.getpxvalue(elem2.posx)), parseInt($scope.getpxvalue(elem2.posy)) + parseInt($scope.getpxvalue(elem2.magassag))/2 );
		}else{
			ctx.moveTo( parseInt($scope.getpxvalue(elem2.posx)) + parseInt($scope.getpxvalue(elem2.szelesseg)) , parseInt($scope.getpxvalue(elem2.posy)) + parseInt($scope.getpxvalue(elem2.magassag))/2 );
			ctx.lineTo( parseInt($scope.getpxvalue(elem1.posx)), parseInt($scope.getpxvalue(elem1.posy)) + parseInt($scope.getpxvalue(elem1.magassag))/2 );				
		}
		*/
		ctx.stroke();
	}
	
	$scope.osszekot = function ( par ){
		
		if ( Array.isArray(par) && par.length==2 ){
			
			var tmp = $scope.rajzparok;
			$scope.clearcanvas();
			$scope.rajzparok = tmp;

			var nincsbenne = true;
			var kivagni = -1;
			
			for (var i = 0, len = $scope.rajzparok.length; i < len; i++) {
				
				if ( $scope.rajzparok[i][0] == par[0] && $scope.rajzparok[i][1] == par[1] || $scope.rajzparok[i][1] == par[0] && $scope.rajzparok[i][0] == par[1] ){
					kivagni = i;
					nincsbenne = false;
					continue;
				}
				
				$scope.vonalhuzas ( $scope.rajzparok[i] );
			}

			if (kivagni != -1){
				$scope.rajzparok.splice( kivagni , 1 );
			}

			
			if (nincsbenne){
				$scope.vonalhuzas ( par );
				$scope.rajzparok.push (par);
			}
			
		}
		
	}

	$scope.utkozes = function( elem1, elem2){
		
		var utkozes = false		
		
		var e1 = { x: parseInt($scope.getpxvalue($scope.items[elem1].posx)), y: parseInt($scope.getpxvalue($scope.items[elem1].posy)), w: parseInt($scope.getpxvalue($scope.items[elem1].szelesseg)), h:parseInt($scope.getpxvalue($scope.items[elem1].magassag)) };

		var e2 = { x: parseInt($scope.getpxvalue($scope.items[elem2].posx)), y: parseInt($scope.getpxvalue($scope.items[elem2].posy)), w: parseInt($scope.getpxvalue($scope.items[elem2].szelesseg)), h:parseInt($scope.getpxvalue($scope.items[elem2].magassag)) };
		
		if ( 
			e2.x <= e1.x && ( e2.x + e2.w ) > e1.x && e2.y <= e1.y && ( e2.y + e2.h ) > e1.y || //bal felső sarok
			e2.x > e1.x && e2.x < (e1.x + e1.w) && e2.y < e1.y && ( e2.y + e2.h ) > e1.y  || //bal fölötte
			
			e2.x < e1.x && ( e2.x + e2.w ) > e1.x && e1.y < e2.y && ( e1.y + e1.h ) > e2.y || //bal mellette sarok
			e2.x > e1.x && e2.x < (e1.x + e1.w) && e2.y > e1.y && ( e1.y + e1.h ) > e2.y  //benne
			
				){
			
			return true;
		}else{
			return false;
		}
		
		return utkozes;
		
	}
	
/* test-code */	
	$scope.masolas = function (){
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				var tempobject = angular.copy($scope.items[i]);
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam!=-1){
			var id = Service.guid();
			tempobject.id = id;	
			
			var patt = /-?\d*/;
						
			var posx = tempobject.posx;
			posx = Number(patt.exec(posx));
			if ( isNaN(posx)){ posx = 0;}
			posx += 10;
						
			var posy = tempobject.posy;
			posy = Number(patt.exec(posy));
			if (isNaN(posy)){ posy = 0;	}
			posy += 10;
			
			tempobject.posx  = posx + "px";
			tempobject.posy = posy + "px";
			
			$scope.items.push (  tempobject );
			$scope.saveitems();
			
			$scope.selectBlock(id);
		}
	
	}
/* end-test-code */	
	
/* test-code */

	$scope.importpage = function (){
		
				var modalInstance = $uibModal.open({
				  animation: $scope.animationsEnabled,
				  templateUrl: 'Playimportalo.html',
				  controller: 'PlayImportCtrl',
				  size: 'lg',
				  resolve: {
					pageid: function () {
						return "";
					}
				}
		});
		
		modalInstance.result.then(function (pageitems) {

			var importalt = angular.fromJson( pageitems );
			
			for (var i = 0, len = importalt.length; i < len; i++) {
				var id = Service.guid();
				importalt[i].id = id;	
				$scope.items.push (  importalt[i] );
			}	
			$scope.saveitems();
			$scope.initpage();
		
		}, function () {
		  $log.info('Modal dismissed at: ' + new Date());
		});
		
	}

/* end-test-code */

	
/* test-code */	
	$scope.szerkeszt = function (size) {

		var modalInstance = $uibModal.open({
				  animation: $scope.animationsEnabled,
				  templateUrl: 'Playszerkeszto.html',
				  controller: 'PlayInstanceCtrl',
				  size: size,
				  resolve: {
					mytext: function () {
					
						var mysorszam = -1;

						for (var i = 0, len = $scope.items.length; i < len; i++) {
							if ($scope.isSelected[$scope.items[i].id]) {
								mysorszam = i;
								break;
							}
						}
				
						if (mysorszam!=-1){
							//return str_replace('\\"', '"', $scope.items[i].szoveg ); 
							//$scope.newString = oldString.replace(/stackover/g,"NO");
							return $scope.items[mysorszam].szoveg.replace(/\\"/g,'"');
							//return $scope.items[i].szoveg;
						}else{
							return "";
						}
					},
					files: function(){
						return $scope.files;
					},
					sizesarray: function(){
						return $scope.sizesarray;
					},
					remote_host: function(){
						return Service.remote_host;
					}
				}
		});
		
		modalInstance.result.then(function (mytext) {

			var mysorszam = -1;

			for (var i = 0, len = $scope.items.length; i < len; i++) {
				if ($scope.isSelected[$scope.items[i].id]) {
					mysorszam = i;
					break;
				}
			}
		
			if (mysorszam!=-1){
				//$scope.items[i].szoveg = angular.toJson(mytext, true);
				//$scope.items[i].szoveg = str_replace('"', '\\"', mytext ); 
				//$scope.items[i].szoveg =  mytext.replace(/"/g,'\\"');
				
				//$log.log ("Előtte" + mytext);
				//$scope.items[mysorszam].szoveg =  mytext;
				
				var temptext = mytext;
				
				//temptext = temptext.replace ( /<span[^<>]*><\/span>/g, '' );
				temptext = temptext.replace ( /<span[^<>]*>&#65279;<\/span>/g, '' );
				temptext = temptext.replace ( /src="\.\.\/content\//g, 'src="'+Service.remote_host+'content/' );
				
				$scope.items[mysorszam].szoveg =  temptext;
				
				//$log.log ("Utána" + mytext.replace ( /<span[^<>]*><\/span>/g, '' ));
				
				//$log.log ("Utána" + mytext.replace ( /<span[^<>]*>&#65279;<\/span>/g, '' ));
			}
		
			//Service.modified = true;
			//Service.saveall();
			$scope.saveitems();
		}, function () {
		  $log.info('Modal dismissed at: ' + new Date());
		});
	};
/* end-test-code */		

/* test-code */
	$scope.szerkesztnagy = function (size) {

		var modalInstance = $uibModal.open({
				  animation: $scope.animationsEnabled,
				  templateUrl: 'Playszerkesztonagy.html',
				  controller: 'PlayInstanceCtrlNagy',
				  size: size,
				  resolve: {
					mytext: function () {
					
						var mysorszam = -1;

						for (var i = 0, len = $scope.items.length; i < len; i++) {
							if ($scope.isSelected[$scope.items[i].id]) {
								mysorszam = i;
								break;
							}
						}
				
						if (mysorszam!=-1){
							return $scope.items[mysorszam].nagyszoveg.replace(/\\"/g,'"');
						}else{
							return "";
						}
					},
					files: function(){
						return $scope.files;
					},
					sizesarray: function(){
						return $scope.sizesarray;
					},
					remote_host: function(){
						return Service.remote_host;
					}
				}
		});
		
		modalInstance.result.then(function (mytext) {

			var mysorszam = -1;

			for (var i = 0, len = $scope.items.length; i < len; i++) {
				if ($scope.isSelected[$scope.items[i].id]) {
					mysorszam = i;
					break;
				}
			}
		
			if (mysorszam!=-1){

				var temptext = mytext;
				
				temptext = temptext.replace ( /<span[^<>]*><\/span>/g, '' );
				temptext = temptext.replace ( /<span[^<>]*>&#65279;<\/span>/g, '' );
				temptext = temptext.replace ( /src="\.\.\/content\//g, 'src="'+Service.remote_host+'content/' );
			
				$scope.items[mysorszam].nagyszoveg =  temptext;
			}
		
			$scope.saveitems();
		}, function () {
		  $log.info('Modal dismissed at: ' + new Date());
		});
	};
/* end-test-code */

/* test-code */
	$scope.szerkesztugras = function (size) {

		var valasztott = "";
		
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				valasztott = $scope.items[i];
				break;
			}
		}
		
		if (valasztott=="") return;
	
		var modalInstance = $uibModal.open({
				  animation: $scope.animationsEnabled,
				  template: '<div style="padding:10px">'+
									'<div class="modal-header"><h3 class="modal-title">Válasszon cél lapot!</h3></div>'+				  
									'<div class="modal-body">Cél lap:'+
										'<ui-select on-select="onSelectCallback($item, $model)" ng-model="cellap" theme="select2" ng-disabled="disabled"  style="min-width: 500px;max-width:500px;height:30px;">'+
										'<ui-select-match placeholder="Nincs">{{$select.selected.name}}</ui-select-match>'+
										'<ui-select-choices repeat="option in pages">'+
										'<div ng-bind-html="option.name" style="display: inline"></div>'+
										'</ui-select-choices></ui-select></div><div class="modal-footer">'+								
									'</div>'+
									'<div class="modal-footer">'+
										'<button class="btn btn-warning" type="button" ng-click="cancel()">Mégsem</button>'+
										'<button class="btn btn-primary" type="button" ng-click="submit()">Mentés</button>'+
									'</div>'+
								'</div>',
								
				  size: size,
				  controller: ['$uibModalInstance', '$scope',
						function($uibModalInstance, $scope) {
							
							$scope.pages = [{id:"", name:"Nincs"}];
							
							for (var i = 0, len = Service.pages.length; i < len; i++) {
								var tempobject = {id:Service.pages[i].page_id, name:Service.pages[i].page_title};
								$scope.pages.push(tempobject);
							}

							var mysorszam = 0;
							
							for (var i = 0, len = $scope.pages.length; i < len; i++) {
								if ($scope.pages[i].id == valasztott.jumpid){
									mysorszam = i;
									break;
								}
							}
							
							$scope.cellap = $scope.pages[mysorszam];
							
							$scope.onSelectCallback = function ($item, $model){
								$scope.cellap = $item;
							}
							
							$scope.submit = function() {
								$uibModalInstance.close($scope.cellap.id);
							};
							
							$scope.cancel = function () {
								$uibModalInstance.dismiss('cancel');
							};
						}
					 ]
		});
		
		modalInstance.result.then(function (mytext) {

			var mysorszam = -1;

			for (var i = 0, len = $scope.items.length; i < len; i++) {
				if ($scope.isSelected[$scope.items[i].id]) {
					mysorszam = i;
					break;
				}
			}
		
			if (mysorszam!=-1){
				$scope.items[mysorszam].jumpid =  mytext;
			}
		
			$scope.saveitems();
			
		}, function () {
		  $log.info('Modal dismissed at: ' + new Date());
		});
	};
/* end-test-code */	

	$scope.tartalomjegyzek = function (size) {

		var tartbody = "";
		var ikon="";
		
		for (var i = 0, len = $scope.pages.length; i < len; i++) {
			
			if ( $scope.pages[i].page_telj == '0' ){
				
				if ( $scope.progress[$scope.pages[i].page_id] ){
					ikon='<i class="fa fa-check-square-o" aria-hidden="true"></i>';
				}else{
					ikon='<i class="fa fa-square-o" aria-hidden="true"></i>';
				}
				
				
			}else{

				if ( $scope.progress[$scope.pages[i].page_id] ){
					ikon='<i class="fa fa-check-square" aria-hidden="true"></i>';
				}else{
					ikon='<i class="fa fa-hourglass-o" aria-hidden="true"></i>';
				}
				
			}


			//$log.log (Service.pages[i]);
			
			if ($scope.adminmode || Service.pages[i].page_hidden != '1'){
			
				var elemem = '<div id="tartelemholder"><div style="float:left;margin-right:'+ (30+parseInt(Service.pages[i].page_indent)*10)+'px" id="tartikonholder">'+ikon+'</div><li class="tartelem level'+Service.pages[i].page_indent+'" > <a style="cursor:pointer" ng-click="tartjump(\''+Service.pages[i].page_id+'\')" >'+Service.pages[i].page_title+'</a></li></div>';

				tartbody += elemem;
			}
		}	

		tartbody = "<ul class='tartjegyzek'>" + tartbody + "</ul>";
		
		var modalInstance = $uibModal.open({
				  animation: $scope.animationsEnabled,
				  template: '<div style="padding:10px">'+
									'<div class="modal-header"><h3 class="modal-title">Tartalomjegyzék</h3></div>'+				  
									'<div class="modal-body">'+tartbody+
									'</div>'+
									'<div class="modal-footer">'+
										'<button class="btn btn-warning" type="button" ng-click="cancel()">Bezár</button>'+
									'</div>'+
							'</div>',
								
				  size: size,
				  controller: ['$uibModalInstance', '$scope',
						function($uibModalInstance, $scope) {
							
							$scope.tartjump = function(id) {
								$uibModalInstance.close(id);
							};
							
							$scope.cancel = function () {
								$uibModalInstance.dismiss('cancel');
							};
						}
					 ]
		});
		
		modalInstance.result.then(function (mytext) {

			$scope.pagejump (mytext);
			
		}, function () {
		  $log.info('Modal dismissed at: ' + new Date());
		});
	};

/* test-code */
	$scope.$on('handleBroadcast', function() {
	
		if  ( Message.szoveg =="closefooter"){
			$scope.show = false;
			$location.path( "/play" );
		}		
		if  ( Message.szoveg =="closeheader"){
			$scope.show = false;
			$location.path( "/play" );
		}
    });
/* end-test-code */

/* test-code */	
	$scope.torles = function (){
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				$scope.isSelected = {};
				$scope.elemvalasztva=false;
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam!=-1){
			 $scope.items.splice(mysorszam, 1);
		}
	
		$scope.saveitems();
	}
/* end-test-code */

/* test-code */		
	$scope.setToInitialState = function() {
		$scope.items.forEach(function(item) {
			$scope.isSelected[item.id] = false;
		});
	};
/* end-test-code */
	
	$scope.itempositions = function (id){
	
		if (id==undefined){
			
			for (var i = 0, len = $scope.items.length; i < len; i++) {
				if ($scope.isSelected[$scope.items[i].id]) {
					id = $scope.items[i].id;
					break;
				}
			}
		}
	
	
		if ($scope.getselected(id) != -1){
	
			var myelem = $scope.items[$scope.getselected(id)];
			
			var modositva = false;

			myelem.testselected = false;
			
			if (myelem.anim==undefined){
				myelem.anim = "";
				modositva = true;
			}
			
			if (myelem.displaystart==undefined){
				myelem.displaystart = "0";
				modositva = true;
			}

			if (myelem.displayend==undefined){
				myelem.displayend = "0";
				modositva = true;
			}
			
			if (myelem.template_id==undefined){
				myelem.template_id = "";
				modositva = true;
			}
			if (myelem.style_id==undefined){
				myelem.style_id = "";
				modositva = true;
			}
			if (myelem.style_data==undefined){
				myelem.style_data = "";
				modositva = true;
			}			
			if (myelem.poster==undefined){
				myelem.poster = "";
				modositva = true;
			}			

			if (myelem.visibleonstart==undefined){
				myelem.visibleonstart = "1";
				modositva = true;
			}

			if (myelem.itemname==undefined){
				myelem.itemname = "";
				modositva = true;
			}

			if (myelem.showitemsclick==undefined){
				myelem.showitemsclick = "";
				modositva = true;
			}			

			if (myelem.hideitemsclick==undefined){
				myelem.hideitemsclick = "";
				modositva = true;
			}			

			if (myelem.mouseover==undefined){
				myelem.mouseover = "hidden";
				modositva = true;
			}			
			
			if (myelem.showitemsover==undefined){
				myelem.showitemsover = "";
				modositva = true;
			}			

			if (myelem.hideitemsleave==undefined){
				myelem.hideitemsleave = "";
				modositva = true;
			}			

			if (myelem.kivalasztas==undefined){
				myelem.kivalasztas = "hidden";
				modositva = true;
			}	

			if (myelem.kivalasztasg==undefined){
				myelem.kivalasztasg = "";
				modositva = true;
			}	

			if (myelem.kivalasztast==undefined){
				myelem.kivalasztast = "no";
				modositva = true;
			}
			
			$scope.itemdata.stilus_selopt_item = $scope.styles[0];
			$scope.itemdata.sablon_selopt_item = $scope.templates[0];
			$scope.itemdata.poster_selopt_item = $scope.bgfiles[0];

			$scope.itemdata.displaystart_selopt_item = $scope.times[0];
			$scope.itemdata.displayend_selopt_item = $scope.times[0];
			$scope.itemdata.anim_selopt_item = $scope.animations[0];

			for (var i = 0, len = $scope.animations.length; i < len; i++) {
				if ($scope.animations[i].anim_type === myelem.anim) {
					$scope.itemdata.anim_selopt_item = $scope.animations[i];
					break;
				}
			}
			
			for (var i = 0, len = $scope.times.length; i < len; i++) {
				if ($scope.times[i].time_title === myelem.displaystart) {
					$scope.itemdata.displaystart_selopt_item = $scope.times[i];
					break;
				}
			}
			for (var i = 0, len = $scope.times.length; i < len; i++) {
				if ($scope.times[i].time_title === myelem.displayend) {
					$scope.itemdata.displayend_selopt_item = $scope.times[i];
					break;
				}
			}
			
			for (var i = 0, len = $scope.styles.length; i < len; i++) {
				if ($scope.styles[i].style_id === myelem.style_id) {
					$scope.itemdata.stilus_selopt_item = $scope.styles[i];
					break;
				}
			}

			for (var i = 0, len = $scope.templates.length; i < len; i++) {
				if ($scope.templates[i].template_id === myelem.template_id) {
					$scope.itemdata.sablon_selopt_item = $scope.templates[i];
					break;
				}
			}

			for (var i = 0, len = $scope.bgfiles.length; i < len; i++) {
				if ($scope.bgfiles[i].id === myelem.poster) {
					$scope.itemdata.poster_selopt_item = $scope.bgfiles[i];
					break;
				}
			}
			
			if (modositva){
				$scope.saveitems();
			}
			
			var patt = /-?\d*/;
	
			$scope.itemdata.selx = $scope.items[$scope.getselected(id)].posx;
			$scope.itemdata.selx = Number(patt.exec($scope.itemdata.selx));
			if ( isNaN($scope.itemdata.selx)){
				$scope.itemdata.selx = 0;
			}
			
			$scope.itemdata.sely = $scope.items[$scope.getselected(id)].posy;
			$scope.itemdata.sely = Number(patt.exec($scope.itemdata.sely));
			if (isNaN($scope.itemdata.sely)){
				$scope.itemdata.sely = 0;
			}
			
			$scope.itemdata.selw = $scope.items[$scope.getselected(id)].szelesseg;
			$scope.itemdata.selw = Number(patt.exec($scope.itemdata.selw));
			if (isNaN($scope.itemdata.selw)){
				$scope.itemdata.selw = 0;
			}

			$scope.itemdata.selh = $scope.items[$scope.getselected(id)].magassag;
			$scope.itemdata.selh = Number(patt.exec($scope.itemdata.selh));
			if (isNaN($scope.itemdata.selh)){
				$scope.itemdata.selh = 0;
			}

			$scope.itemdata.selp = $scope.items[$scope.getselected(id)].padding;
			$scope.itemdata.selp = Number(patt.exec($scope.itemdata.selp));
			if (isNaN($scope.itemdata.selp)){
				$scope.itemdata.selp = 0;
			}
			
			$scope.itemdata.selo = $scope.items[$scope.getselected(id)].overflow;
			if ($scope.itemdata.selo != "visible" && $scope.itemdata.selo != "hidden" && $scope.itemdata.selo != "auto"){
				$scope.itemdata.selo = "hidden";
			}

			$scope.itemdata.selm = $scope.items[$scope.getselected(id)].magnify;
			if ($scope.itemdata.selm != "visible" && $scope.itemdata.selm != "hidden" && $scope.itemdata.selm != "picture" && $scope.itemdata.selm != "jump" && $scope.itemdata.selm != "click" && $scope.itemdata.selm != "test" ){
				$scope.itemdata.selm = "hidden";
			}

			$scope.itemdata.kiv = $scope.items[$scope.getselected(id)].kivalasztas;
			if ($scope.itemdata.kiv != "egyszeres" && $scope.itemdata.kiv != "hidden" && $scope.itemdata.kiv != "tobbszoros" && $scope.itemdata.kiv != "eredmeny" && $scope.itemdata.kiv != "testcheck" && $scope.itemdata.kiv != "halmaz" && $scope.itemdata.kiv != "halmazelem" && $scope.itemdata.kiv != "osszekotos" && $scope.itemdata.kiv != "ujra"){
				$scope.itemdata.kiv = "hidden";
			}
			
			$scope.itemdata.kivg = $scope.items[$scope.getselected(id)].kivalasztasg;
			$scope.itemdata.kivt = $scope.items[$scope.getselected(id)].kivalasztast;
			if ($scope.itemdata.kivt != "yes" && $scope.itemdata.kivt != "no"){
				$scope.itemdata.kivt = "no";
			}
			
			$scope.itemdata.selmo = $scope.items[$scope.getselected(id)].mouseover;
			if ($scope.itemdata.selmo != "visible" && $scope.itemdata.selmo != "hidden"){
				$scope.itemdata.selmo = "hidden";
			}
			
			$scope.itemdata.vida = $scope.items[$scope.getselected(id)].autoplay;
			if ($scope.itemdata.vida != "0" && $scope.itemdata.vida != "1"){
				$scope.itemdata.vida = "0";
			}

			$scope.itemdata.vidk = $scope.items[$scope.getselected(id)].videobuttons;
			if ($scope.itemdata.vidk != "0" && $scope.itemdata.vidk != "1"){
				$scope.itemdata.vidk = "0";
			}

			$scope.itemdata.vidh = $scope.items[$scope.getselected(id)].autohide;
			$scope.itemdata.vidh = Number(patt.exec($scope.itemdata.vidh));
			if (isNaN($scope.itemdata.vidh)){
				$scope.itemdata.vidh = 0;
			}

			$scope.itemdata.behuz = $scope.items[$scope.getselected(id)].behuz;
			if ($scope.itemdata.behuz != "0" && $scope.itemdata.behuz != "1"){
				$scope.itemdata.behuz = "0";
			}
			
			//$scope.selvisibleonstart =  Number($scope.items[$scope.getselected(id)].visibleonstart);
			//$scope.selitemname =  $scope.items[$scope.getselected(id)].itemname;
			$scope.itemdata.selitemname =  $scope.items[$scope.getselected(id)].itemname;
			$scope.itemdata.selvisibleonstart =  Number($scope.items[$scope.getselected(id)].visibleonstart);
			
			$scope.itemdata.selshowitemsclick =  $scope.items[$scope.getselected(id)].showitemsclick;
			$scope.itemdata.selhideitemsclick =  $scope.items[$scope.getselected(id)].hideitemsclick;
			$scope.itemdata.selshowitemsover =  $scope.items[$scope.getselected(id)].showitemsover;
			$scope.itemdata.selhideitemsleave =  $scope.items[$scope.getselected(id)].hideitemsleave;
			
			
		}
	
	}

/* test-code */		
	$scope.selectBlock = function(id, $event) {
		
	
		$scope.itemdata.elemtipus = "";
		
		$scope.isSelected[id] = true;
		if ($scope.isSelected[id]) {
		  $scope.items.forEach(function(item) {
			if (item.id !== id) {
			  $scope.isSelected[item.id] = false;
			}else{
				$scope.itempositions(id);
			}
		  });
		  $scope.elemvalasztva = true;
		  if (  $scope.isanim ( $scope.items[$scope.getselected(id)].szoveg) ){
			  $scope.itemdata.elemtipus = "animation";
		  }else if ( $scope.isvideo ( $scope.items[$scope.getselected(id)].szoveg)){
			  $scope.itemdata.elemtipus = "video";
		  }else{
			  $scope.itemdata.elemtipus = "normal";
		  }
		}
		else {
		  $scope.setToInitialState();
		  $scope.elemvalasztva = false;
		}

		if ($event){
			$event.stopPropagation();
		}
		
	};
/* end-test-code */

/* test-code */		
	$scope.unselectBlock = function() {
		$scope.isSelected = {};
		$scope.elemvalasztva = false;
	};	
/* end-test-code */
		
  	$scope.getselected = function(myid) {
	
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.items[i].id === myid) {
				return i;
				break;
			}
		}
		return -1;
	};
 
  	$scope.isselected = function(myid) {	
		//console.log (myid);
		return  $scope.isSelected[myid]
	};
 
/* test-code */	
	$scope.visszaallitas = function (){
	
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			$scope.items[i].posx = "10px";
			$scope.items[i].posy = "10px";
			$scope.items[i].szelesseg = "100px";
			$scope.items[i].magassag = "100px";
			
			document.getElementById($scope.items[i].id).style.top = "10px";
			document.getElementById($scope.items[i].id).style.left = "10px";
			
		}
		//Service.items = $scope.items;
		//Service.modified = true;
		$scope.saveitems();
		$scope.itempositions();
	}
/* end-test-code */
	
	$scope.events = [];

/* test-code */		
	$scope.$on("angular-resizable.resizing", function (event, args) {
	
		//$log.log (args);
	
		if (args.irany == "rg-top"){
			
				var sorszam = $scope.getitemnumberbyid(args.id);
				var ujmeret = args.height;
				
				$scope.items[sorszam].posy = ($scope.meretezesreferencia - ( ujmeret - $scope.meretezesmeret ) ) + "px";
				jQuery( "#"+args.id ).css('top', ($scope.meretezesreferencia - ( ujmeret - $scope.meretezesmeret ) ) + "px");
				
			
		}
	
	});
/* end-test-code */

/* test-code */		
	$scope.$on("angular-resizable.resizeStart", function (event, args) {

		$scope.meretezesirany = args.irany;
		
		if ($scope.meretezesirany == "rg-top"){
			$scope.meretezesmeret = $scope.getpxvalue($scope.items[$scope.getitemnumberbyid(args.id)].magassag);
			$scope.meretezesreferencia = $scope.getpxvalue($scope.items[$scope.getitemnumberbyid(args.id)].posy);
		}else if ($scope.meretezesirany == "rg-right"){
			$scope.meretezesmeret = $scope.getpxvalue($scope.items[$scope.getitemnumberbyid(args.id)].szelesseg);
			$scope.meretezesreferencia = $scope.getpxvalue($scope.items[$scope.getitemnumberbyid(args.id)].posx);
		}if ($scope.meretezesirany == "rg-bottom"){
			$scope.meretezesmeret = $scope.getpxvalue($scope.items[$scope.getitemnumberbyid(args.id)].magassag);
			$scope.meretezesreferencia = $scope.getpxvalue($scope.items[$scope.getitemnumberbyid(args.id)].posy);
		}else if ($scope.meretezesirany == "rg-left"){
			$scope.meretezesmeret = $scope.getpxvalue($scope.items[$scope.getitemnumberbyid(args.id)].szelesseg);
			$scope.meretezesreferencia = $scope.getpxvalue($scope.items[$scope.getitemnumberbyid(args.id)].posx);
		}
		
	});
/* end-test-code */
	
	$scope.getpxvalue = function ( value ){

		var regExp = /^(\d+\.?\d*)px$/;
		var matches = regExp.exec(value);
		if (matches && matches.length){
			return matches[1];					
		}else{
			return parseInt(value);					
		}
	}
				
	
	$scope.getitemnumberbyid = function (id){
		
		var myid = id;
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.items[i].id === myid) {
				mysorszam = i;
				break;
			}
		}
		
		return mysorszam;
	}

/* test-code */	
	$scope.$on("angular-resizable.resizeEnd", function (event, args) {

		$scope.events.unshift(event);
		$scope.size = args;
		
		var myid = args.id;
		var mysorszam = 0;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.items[i].id === myid) {
				mysorszam = i;
				break;
			}
		}

		//$log.log (args);

		var regExp = /^(\d+\.?\d*)px$/;

		
		if(args.width){
			
			if (args.vezerlo == "ctrl") $scope.items[mysorszam].magassag = args.width + "px";
			if (args.vezerlo == "shift"){
				var elozox = 0;
				var elozoy = 0;
				var arany = 1;
				
				var matches = regExp.exec($scope.items[mysorszam].szelesseg);
				if (matches && matches.length){
					var elozox = matches[1];					
				}
				if (elozox != 0 && args.width != 0){
					arany = args.width / elozox;
				}
				
				var matches = regExp.exec($scope.items[mysorszam].magassag);
				if (matches && matches.length){
					var elozoy = matches[1];					
				}
				$scope.items[mysorszam].magassag = (elozoy * arany) + "px";
			}
			
			if ($scope.snaptogrid == '1'){
				$scope.items[mysorszam].szelesseg = Math.round ( args.width/5 ) * 5 + "px";
			}else{
				$scope.items[mysorszam].szelesseg = args.width + "px";
			}
			
		}
		
		if(args.height){
			if (args.vezerlo == "ctrl") $scope.items[mysorszam].szelesseg = args.height + "px";
			
			if (args.vezerlo == "shift"){
				var elozox = 0;
				var elozoy = 0;
				var arany = 1;
				
				var matches = regExp.exec($scope.items[mysorszam].magassag);
				if (matches && matches.length){
					var elozoy = matches[1];					
				}
				if (elozoy != 0 && args.height != 0){
					arany = args.height / elozoy;
				}
				
				var matches = regExp.exec($scope.items[mysorszam].szelesseg);
				if (matches && matches.length){
					var elozox = matches[1];					
				}
				$scope.items[mysorszam].szelesseg = (elozox * arany) + "px";
			}
			
			if ($scope.snaptogrid == '1'){
				$scope.items[mysorszam].magassag = Math.round ( args.height/5 ) * 5 + "px";
			}else{
				$scope.items[mysorszam].magassag = args.height + "px";
			}
			
		}
		
		$scope.saveitems();

	});
/* end-test-code */	

 	$scope.huzas = function (event, ui){
		
		var element = document.querySelector('#teljesterulet');
		if (!element) return;
		var percent = element.getBoundingClientRect().width / element.offsetWidth;

		var changeLeft = ui.position.left - ui.originalPosition.left, newLeft = ui.originalPosition.left + changeLeft / percent, changeTop = ui.position.top - ui.originalPosition.top, newTop = ui.originalPosition.top + changeTop / percent; ui.position.left = newLeft; ui.position.top = newTop;

	}

 	$scope.elindult = function (event, ui){
		ui.position.left = 0; ui.position.top = 0;  var element = $(this);
	}

	
 	$scope.megallt = function (event, ui){
	
		var myid = event.target.id;
		var mysorszam = 0;

		
		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.items[i].id === myid) {
				mysorszam = i;
				break;
			}
		}
		
		var myelem = $scope.items[mysorszam];

/* test-code */				
		if ($scope.snaptogrid == '1'){
			$scope.items[mysorszam].posx = Math.round(ui.position.left/5)*5 + "px";
			$scope.items[mysorszam].posy = Math.round(ui.position.top/5)*5 + "px";
		}else{
/* end-test-code */	
			$scope.items[mysorszam].posx = ui.position.left + "px";
			$scope.items[mysorszam].posy = ui.position.top + "px";		
/* test-code */				
		}
/* end-test-code */	
		
		$scope.items[mysorszam].szelesseg = event.target.style.width;
		$scope.items[mysorszam].magassag = event.target.style.height;
	
		if (mysorszam != -1 && !$scope.adminmode){		
			if (myelem.kivalasztas == "halmazelem"){
				if ( $scope.items[mysorszam].behuz ){
					
					for (var i = 0, len = $scope.items.length; i < len; i++) {
						if ( i != mysorszam &&  $scope.items[i].kivalasztas == "halmaz") {
							if ($scope.utkozes(i, mysorszam)){
								//console.log($scope.items[i]);
								
								//console.log(angular.element(event.target).prop('offsetLeft'));
								//console.log( $scope.getpxvalue($scope.items[i].posx));
								//angular.element(event.target).prop('offsetLeft') = $scope.getpxvalue($scope.items[i].posx);
								
								$scope.items[mysorszam].posx = $scope.getpxvalue($scope.items[i].posx)+"px";
								$scope.items[mysorszam].posy = $scope.getpxvalue($scope.items[i].posy)+"px";
								
								//ui.position.left = $scope.getpxvalue($scope.items[i].posx);
								//ui.position.top = $scope.getpxvalue($scope.items[i].posy);
								return;
							}
						}
					}
				} 
				return;
			}
		}
/* test-code */
		
		$scope.itempositions(myid);	
		$scope.saveitems();
/* end-test-code */	
				  
	}

/* test-code */	
 	$scope.megvaltozott = function (event, ui){
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
		if (mysorszam != -1){

			//if ($scope.snaptogrid == '1'){
			//	$scope.items[mysorszam].posx = Math.round($scope.selx/5)*5 + "px";
			//	$scope.items[mysorszam].posy = Math.round($scope.sely/5)*5 + "px";
			//}else{
				$scope.items[mysorszam].posx = $scope.itemdata.selx + "px";
				$scope.items[mysorszam].posy = $scope.itemdata.sely + "px";
			//}
			
			$scope.items[mysorszam].szelesseg = $scope.itemdata.selw + "px";
			$scope.items[mysorszam].magassag = $scope.itemdata.selh + "px";
			$scope.items[mysorszam].padding = $scope.itemdata.selp + "px";
			$scope.items[mysorszam].overflow = $scope.itemdata.selo;
			$scope.items[mysorszam].magnify = $scope.itemdata.selm;
			$scope.items[mysorszam].autoplay = $scope.itemdata.vida;
			$scope.items[mysorszam].videobuttons = $scope.itemdata.vidk;
			$scope.items[mysorszam].autohide = $scope.itemdata.vidh;
			//$scope.items[mysorszam].visibleonstart = $scope.selvisibleonstart;
			$scope.items[mysorszam].visibleonstart = $scope.itemdata.selvisibleonstart;
			//$scope.items[mysorszam].itemname = $scope.selitemname;
			$scope.items[mysorszam].itemname = $scope.itemdata.selitemname;
			$scope.items[mysorszam].mouseover = $scope.itemdata.selmo;

			$scope.items[mysorszam].kivalasztas = $scope.itemdata.kiv;
			$scope.items[mysorszam].kivalasztasg = $scope.itemdata.kivg;
			$scope.items[mysorszam].kivalasztast = $scope.itemdata.kivt;
			
			$scope.items[mysorszam].showitemsclick = $scope.itemdata.selshowitemsclick;
			$scope.items[mysorszam].hideitemsclick = $scope.itemdata.selhideitemsclick;
			$scope.items[mysorszam].showitemsover = $scope.itemdata.selshowitemsover;
			$scope.items[mysorszam].hideitemsleave = $scope.itemdata.selhideitemsleave;
			$scope.items[mysorszam].behuz = $scope.itemdata.behuz;
		
			var value = ( $scope.itemdata.vida == "1");
		
			$scope.toggleAutoplay ($scope.items[mysorszam].id, value);
			$scope.saveitems();

		}
				  
	}
/* end-test-code */		

/* test-code */	
	 $scope.felulre = function (event, ui){
	
	
		var mysorszam = -1;

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.isSelected[$scope.items[i].id]) {
				mysorszam = i;
				break;
			}
		}
		
 		if (mysorszam != -1){

			var newitem = $scope.items.splice(mysorszam, 1);
			
			if (newitem.length == 1){
				$scope.items.push (newitem[0]);
				$scope.isSelected = {};
				$scope.elemvalasztva = false;
				$scope.saveitems();
				
				$scope.selectBlock(newitem[0].id);
			}

		}
				  
	}
/* end-test-code */	
	
	$scope.gettemplatestyles = function(){
	
			//console.log ("gettemplatestyles");
	
			var stylestoadd = "";
			
			for (var i = 0, len = $scope.templates.length; i < len; i++) {
					var mytemplate = $scope.templates[i];
					for (var j = 0, len2 = $scope.items.length; j < len2; j++) {
						if ($scope.items[j].template_id == mytemplate.template_id && mytemplate.template_id!=""){
						
									var toadd = mytemplate.template_style;
									if (Service.offline){
										toadd = toadd.replace(/\.\.\/content/g,"content");
									}else{
										//console.log(toadd);
										//toadd = toadd.replace(/(src=['"])[^'"]*(content[^']*)/g,"$1"+Service.remote_host+"$2");
										toadd = toadd.replace(/url[^\(\)]*?\([^\(\)]*?(content[^\(\)]*?)\)/g,"url("+Service.remote_host+"$1)");
										//console.log(toadd);
										//$scope.pages[i].page_items[j].szoveg = $scope.pages[i].page_items[j].szoveg.replace(/(src=['"])[^'"]*(content[^']*)/g,"$1"+Service.remote_host+"$2");
									}
							stylestoadd += toadd;
							break
						}
					}
			}
			
			$scope.templatestyles = stylestoadd;
	}

	$scope.getstylestyles = function(){
	
			//console.log ("getstylestyles");
	
			var stylestoadd = "";
			
			for (var i = 0, len = $scope.styles.length; i < len; i++) {
					var mytemplate = $scope.styles[i];
					for (var j = 0, len2 = $scope.items.length; j < len2; j++) {
						if ($scope.items[j].style_id == mytemplate.style_id && mytemplate.style_id!=""){
							
							stylestoadd += mytemplate.style_data.replace(/url[^\(\)]*?\([^\(\)]*?(content[^\(\)]*?)\)/g,"url("+Service.remote_host+"$1)");			
							//console.log ( stylestoadd );
							break
						}
					}
			}
			
			$scope.stylestyles = stylestoadd;
	}

	$scope.getprivatestyles = function(){
	
			var stylestoadd = "";
			
			for (var j = 0, len2 = $scope.items.length; j < len2; j++) {
				stylestoadd += $scope.items[j].style_data;
			}
			
			$scope.privatestyles = stylestoadd;
	}
	
	$scope.getstyles = function(id, admin, container){
	
		var myobj = {};

		for (var i = 0, len = $scope.items.length; i < len; i++) {
			if ($scope.items[i].id === id) {
				
				//if (admin == 'admin'){
					if (container == "outer"){
						myobj = { width: $scope.items[i].szelesseg, height: $scope.items[i].magassag, left: $scope.items[i].posx, top: $scope.items[i].posy};						
					}else{
						if ($scope.items[i].overflow == "visible"){
							myobj = { width: "100%", "min-height": "100%", left: $scope.items[i].posx, top: $scope.items[i].posy, padding: $scope.items[i].padding, "overflow-y": $scope.items[i].overflow};
						}else{
							myobj = { width: "100%", "height": "100%", left: $scope.items[i].posx, top: $scope.items[i].posy, padding: $scope.items[i].padding, "overflow-y": $scope.items[i].overflow};							
						}
					}
					
					if ( $scope.items[i].magnify != "hidden"){
						myobj.cursor = "pointer";
					}
					
				break;
			}
		}
		
		return (myobj);
	
	};
	
  }])
 
/* test-code */	
.controller('PlayInstanceCtrlNagy', function ($scope, $uibModalInstance, mytext, files, sizesarray, remote_host) {

		$scope.tinymceOptions = {
			plugins: [
				'advlist autolink lists link image charmap print preview hr anchor pagebreak',
				'searchreplace wordcount visualblocks visualchars code fullscreen',
				'insertdatetime media nonbreaking save table contextmenu directionality',
				'emoticons template paste textcolor colorpicker textpattern imagetools equationeditor '
			],
			toolbar1: 'insertfile undo redo | styleselect fontselect fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
			toolbar2: 'print preview media | forecolor backcolor emoticons  equationeditor ',
			image_advtab: true,
			relative_url : false,
			//content_css : "css/fonts.css",
			theme_advanced_font_sizes : "8px,10px,12px,14px,16px,18px,20px,24px,32px,36px",
			font_formats : 'Andale Mono=andale mono,times;'+ 'Arial=arial,helvetica,sans-serif;'+ 'Arial Black=arial black,avant garde;'+ 'Book Antiqua=book antiqua,palatino;'+ 'Comic Sans MS=comic sans ms,sans-serif;'+ 'Courier New=courier new,courier;'+ 'Georgia=georgia,palatino;'+ 'Helvetica=helvetica;'+ 'Impact=impact,chicago;'+ 'Symbol=symbol;'+ 'Tahoma=tahoma,arial,helvetica,sans-serif;'+ 'Terminal=terminal,monaco;'+ 'Times New Roman=times new roman,times;'+ 'Trebuchet MS=trebuchet ms,geneva;'+ 'Verdana=verdana,geneva;'+ 'Webdings=webdings;'+ 'Wingdings=wingdings,zapf dingbats;'+'Pridi=Pridi, serif;'+'Open Sans=Open Sans, sans-serif;'+'Roboto=Roboto, sans-serif;'+ 'Slabo 27px=Slabo 27px, serif;'+'Oswald=Oswald, sans-serif;'+'Marcellus SC=Marcellus SC, serif;'+'Allura=Allura, cursive;',
			extended_valid_elements : 'math[class|id|xmlns|altimg|alttext|display|overflow],semantics[encoding|definitionURL],annotation[encoding|definitionURL|cd|name|src],annotation-xml[cd|name|encoding|definitionURL|src],merror,mtext,mspace,mover[accent|align],munder,munderover,mstack,mrow[dir],msrow,mfenced[open|close|separators],menclose[notation],mphantom,msup,msub,msubsup,mmultiscripts,mi,mn,mo[fence],ms,mtable,mtr,mtd,mlabeledtr,mfrac[linethickness|bevelled|numalign|denomalign],mfraction,msline,msqrt,mroot,mscarries,mscarry,span[class|align|style]'

		};

	  $scope.mytext = mytext;
	  $scope.files = files;
	  $scope.sizesarray = sizesarray;
	  $scope.remote_host = remote_host;
	  $scope.meret100 = 0;
	  
	  	if ($scope.files.length){
			$scope.background_selopt_item = $scope.files[0];
		}
	  
	  $scope.onSelectItemCallback = function ($item, $model){
	
		var $htmltext = "";

		//console.log ($item);
		
		if ($item.type=="image"){
			
				if ($scope.meret100 == 0){
					
					var origx = 100;
					var origy = 100;
					
					var kepmeretarany = $scope.sizesarray[$item.id].height / $scope.sizesarray[$item.id].width;
					origy = Math.round (origx * kepmeretarany);
						
					origx = origx + "px";
					origy = origy + "px";
					
					$htmltext = "<img width='" + origx + "' height='" + origy + "' src='" + $scope.remote_host + $item.id.replace(/ /g,"%20") + "'></img>";
												
				}else{
					
					var xmeret = $scope.sizesarray[$item.id].width + "px";
					var ymeret = $scope.sizesarray[$item.id].height + "px";
			
					$htmltext = "<img width='" + xmeret + "' height='"+ymeret+"' src='" + $scope.remote_host + $item.id.replace(/ /g,"%20") + "'></img>";
				
				}
			
			$scope.mytext = $htmltext + $scope.mytext;
				
		}else if ( $item.type == "video"){
				$scope.mytext = "{video}" + $scope.remote_host + $scope.background_selopt_item.id.replace(/ /g,"%20") + "{/video}";
		}
		
		if ($scope.files.length){
			$scope.background_selopt_item = $scope.files[0];
		}
		
		
	}
	

	  
	  $scope.ok = function () {
		$uibModalInstance.close($scope.mytext);
	  };

	  $scope.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	  };
  })
/* end-test-code */	


/* test-code */	
 .controller('PlayImportCtrl', function ($scope, $uibModalInstance, pageid, Service) {

		$scope.pageitems = "";

		$scope.packages = [{id:"", name:"Nincs"}];
		$scope.packages_selopt = $scope.packages[0];

		$scope.pages = [{id:"", name:"Nincs", items:""}];
		$scope.pages_selopt = $scope.pages[0];
		
		for (var i = 0, len = Service.packages.length; i < len; i++) {		
			var tempobject = {id:Service.packages[i].package_id, name:Service.packages[i].package_title};
			$scope.packages.push(tempobject);
		}	

		$scope.$watch(function () { return Service.pagelist; },function (value) {
		
			$scope.pages = [{id:"", name:"Nincs", items:""}];
			$scope.pages_selopt = $scope.pages[0];
			
			for(var i = 0; i < value.length; i++){
				var tempobject = {id:Service.pagelist[i].page_id, name:Service.pagelist[i].page_title, items: Service.pagelist[i].page_items};
				$scope.pages.push(tempobject);
			}
			
		});	
		
	   $scope.onSelectItemCallback = function ($item, $model){
			Service.listpages ($item.id);
			Service.pagelist = [];
			$scope.pageitems="";
	   }
	   
	   	$scope.onSelectItem2Callback = function ($item, $model){
			$scope.pageitems = $item.items;
	    }
	  
		$scope.ok = function () {
			$uibModalInstance.close($scope.pageitems);
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	  
  })
/* end-test-code */	 

 .controller('MagnifyInstanceCtrl', function ($scope, Service, $sce, $uibModalInstance, mytext, mytitle) {

	  $scope.mytext = mytext;
	  $scope.mytitle = mytitle;
	  $scope.videoconfigs = {};

	  //console.log ("Fut");
	  
	  $scope.videoloading = true;
	  
		$scope.config = {
			theme: "bower_components/videogular-themes-default/videogular.css",
			plugins: {
				controls: {
					autoHide: true,
					autoHideTime: 0
				}
			}
		};
	  
	  	$scope.onUpdateTime = function ($currentTime, $duration){
		
			$scope.videoloading = false;
			
			function timerComplete () {
				$scope.videoloading = false;
			}

			if ( $scope.videoloading == true){
				setTimeout(timerComplete, 200);
			}
		
		}
	  
		$scope.isvideo = function (param){
		
			//console.log (param+"!!! isvid");
		
			var regex = /\{video\}/;
		
			if ( param != undefined && param.match( regex )){
				return true;
			}else{
				return false;
			}
		};
	
		$scope.onPlayerReady = function(API) {
			API.autoPlay = true;
		};	
		
		$scope.getsource = function (szoveg){
			
			//console.log (szoveg+ "!!! fets");
			
			if (!$scope.isvideo(szoveg)){
				return;
			}else{
			
				if (!$scope.videoconfigs[szoveg]){
				
					var regExp = /{video}([\s\S]*){\/video}/;
					var matches = regExp.exec(szoveg);
				
					if (matches && matches.length){

						var value = matches[1];
						if (Service.offline){
							value = value.replace(/^http:\/\/[^\/]*?\//g,"");
							var tmpstring = value.replace(/ /g,"%20");
						}else{
							var tmpstring = value.replace(/ /g,"%20");
						}
					
						console.log ("tmpstring:" + tmpstring);
				
						$scope.videoconfigs[szoveg] = {	
							sources: [
								{src: $sce.trustAsResourceUrl( tmpstring ), type: "video/mp4"}
							],
							theme: "bower_components/videogular-themes-default/videogular.css"

						};
					}
				}
			
				return $scope.videoconfigs[szoveg].sources;
			}
		
		};
	  
		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
		
		$scope.ezvideo = $scope.isvideo (mytext);
		$scope.forrasom = $scope.getsource (mytext);

		
  })

/* test-code */	
/*
.controller('FajlvalasztoCtrl', function ($scope, $uibModalInstance, mytext, $uibModal, $log, Service ) {

		$scope.pickedfile = "";
		Service.pickedfile = "";

		$scope.valami="szoveg";
		
		$scope.$watch(function () { return Service.pickedfile; },function (value) {
		
			$scope.pickedfile = value;
			console.log (value);
			
		});

	  $scope.nyomtat = function () {
		console.log ("Service");
		console.log (Service);
	  };
		


	  $scope.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	  };

})
*/
 .controller('PlayInstanceCtrl', function ($scope, $uibModalInstance, mytext, files, sizesarray, remote_host, $uibModal, $log, Service) {

 	//HTML szerkesztése ablak
	
		$scope.textscreen = true;
		$scope.pickedfile = "";
		Service.pickedfile="";
	
		$scope.$watch(function () { return Service.pickedfile; },function (value) {
		
			if (value=="") return;
		
			//$scope.pickedfile = value;
			//console.log (value);
			
			for (var i = 0, len = $scope.files.length; i < len; i++) {		
				//console.log($scope.files[i]);
				if (value == $scope.files[i].id && $scope.files[i].type=="image"){
					$scope.pickedfile = value;
				}
			}	
			
			
		});
		
		$scope.fajlmentes = function (){
			//console.log ("Most mentem:" + $scope.pickedfile);
			$scope.textscreen= true;
			
			for (var i = 0, len = $scope.files.length; i < len; i++) {		
				//console.log($scope.files[i]);
				if ($scope.pickedfile == $scope.files[i].id && $scope.files[i].type=="image"){
					 $scope.onSelectItemCallback($scope.files[i]);
					 break;
				}
			}
			
			$scope.pickedfile = "";
			Service.pickedfile="";
			
		}
	
		$scope.tinymceOptions = {
			plugins: [
				'advlist autolink lists link image charmap print preview hr anchor pagebreak',
				'searchreplace wordcount visualblocks visualchars code fullscreen',
				'insertdatetime media nonbreaking save table contextmenu directionality',
				'emoticons template paste textcolor colorpicker textpattern imagetools equationeditor '
			],
			toolbar1: 'insertfile undo redo | styleselect fontselect fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
			toolbar2: 'print preview media | forecolor backcolor emoticons  equationeditor ',
			image_advtab: true,
			relative_url : false,
			content_css : "css/fonts.css",
			theme_advanced_font_sizes : "8px,10px,12px,14px,16px,18px,20px,24px,32px,36px",
			font_formats : 'Andale Mono=andale mono,times;'+ 'Arial=arial,helvetica,sans-serif;'+ 'Arial Black=arial black,avant garde;'+ 'Book Antiqua=book antiqua,palatino;'+ 'Comic Sans MS=comic sans ms,sans-serif;'+ 'Courier New=courier new,courier;'+ 'Georgia=georgia,palatino;'+ 'Helvetica=helvetica;'+ 'Impact=impact,chicago;'+ 'Symbol=symbol;'+ 'Tahoma=tahoma,arial,helvetica,sans-serif;'+ 'Terminal=terminal,monaco;'+ 'Times New Roman=times new roman,times;'+ 'Trebuchet MS=trebuchet ms,geneva;'+ 'Verdana=verdana,geneva;'+ 'Webdings=webdings;'+ 'Wingdings=wingdings,zapf dingbats;'+'Pridi=Pridi, serif;'+'Open Sans=Open Sans, sans-serif;'+'Roboto=Roboto, sans-serif;'+ 'Slabo 27px=Slabo 27px, serif;'+'Oswald=Oswald, sans-serif;'+'Marcellus SC=Marcellus SC, serif;'+'Allura=Allura, cursive;',
			extended_valid_elements : 'math[class|id|xmlns|altimg|alttext|display|overflow],semantics[encoding|definitionURL],annotation[encoding|definitionURL|cd|name|src],annotation-xml[cd|name|encoding|definitionURL|src],merror,mtext,mspace,mover[accent|align],munder,munderover,mstack,mrow[dir],msrow,mfenced[open|close|separators],menclose[notation],mphantom,msup,msub,msubsup,mmultiscripts,mi,mn,mo[fence],ms,mtable,mtr,mtd,mlabeledtr,mfrac[linethickness|bevelled|numalign|denomalign],mfraction,msline,msqrt,mroot,mscarries,mscarry,span[class|align|style]'

		};
  
	  $scope.mytext = mytext;
	  $scope.files = files;
	  $scope.sizesarray = sizesarray;
	  $scope.remote_host = remote_host;
	  $scope.meret100 = 0;
	  
	  	if ($scope.files.length){
			$scope.background_selopt_item = $scope.files[0];
		}
	  
	  $scope.onSelectItemCallback = function ($item, $model){
	
		//console.log ($item);
	
		var $htmltext = "";
		
		if ($item.type=="image"){
			
				if ($scope.meret100 == 0){
					
					var origx = 100;
					var origy = 100;
					
					var kepmeretarany = $scope.sizesarray[$item.id].height / $scope.sizesarray[$item.id].width;
					origy = Math.round (origx * kepmeretarany);
						
					origx = origx + "px";
					origy = origy + "px";
					
					$htmltext = "<img width='" + origx + "' height='" + origy + "' src='" + $scope.remote_host + $item.id.replace(/ /g,"%20") + "'></img>";
												
				}else{
					
					var xmeret = $scope.sizesarray[$item.id].width + "px";
					var ymeret = $scope.sizesarray[$item.id].height + "px";
			
					$htmltext = "<img width='" + xmeret + "' height='"+ymeret+"' src='" + $scope.remote_host + $item.id.replace(/ /g,"%20") + "'></img>";
					
				}
				
				$scope.mytext = $htmltext + $scope.mytext;
			
		}

		
		if ($scope.files.length){
			$scope.background_selopt_item = $scope.files[0];
		}
		
	}
	
	$scope.tofile = function () {
			$scope.textscreen=false;
	};
	
	$scope.totext = function () {
			$scope.textscreen=true;
			$scope.pickedfile = "";
			Service.pickedfile="";
	};
	  
	  $scope.ok = function () {
		$uibModalInstance.close($scope.mytext);
	  };

	  $scope.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	  };
	  
	  $scope.cleanup = function(){
		  
			var szovegem = $scope.mytext;
		  
			//szovegem = szovegem.replace(/<\/?span[^<>]*?>/g,"");
			//szovegem = szovegem.replace(/<br\/?>/g," ");
			
			//szovegem = szovegem.replace(/<b>/g,"<strike>");
			//szovegem = szovegem.replace(/<\/b>/g,"</strike>");
			
			$uibModalInstance.close(szovegem);
	  }
	  
  })
/* end-test-code */	 
 
/* test-code */	
 .controller('StyleInstanceCtrl', function ($scope, $uibModalInstance, mystyle) {

	  $scope.mystyle = mystyle;

	  $scope.ok = function () {
		$uibModalInstance.close($scope.mystyle);
	  };

	  $scope.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	  };
  })
 /* end-test-code */
 
  
 .controller('PopupTitleInstanceCtrl', function ($scope, $uibModalInstance, mytitle) {

	  $scope.mytitle = mytitle;

	  $scope.ok = function () {
		$uibModalInstance.close($scope.mytitle);
	  };

	  $scope.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	  };
  });
  
  